export default {
  all: "Tutti",
  close: "Chiudi",
  actions: {
    confirm: "Conferma",
    cancel: "Annulla",
    correct: "Correggi",
    showAll: "Guarda tutte",
    edit: "Modifica",
    delete: "Elimina",
    share: "Condividi",
    download: "Download",
    display: "Visualizza",
    close: "Chiudi",
    duplicate: "Duplica",
    goDocuments: "Vai a documenti",
    goDeadline: "Vai alla scadenza",
    add: "Aggiungi",
    pay: "Paga",
    save: "Salva",
    discoverMore: "Scopri di più",
    activate: "Attiva subito",
    goBack: "Torna indietro",
    insert: "Inserisci",
    addComment: "Inserisci commento",
    search: "Cerca",
    login: "Accedi",
  },
  saved: "Salvato",
  minute: "minuto",
  minutes: "minuti",
  ago: "fa",
  generalText: {
    orText: "oppure",
    ts: "TeamSystem",
  },
  usedGoods: {
    title: "Gestione beni usati",
  },
  upload: {
    newDocument: "Carica nuovi documenti",
    orNewDocument: "Oppure carica nuovi documenti",
    acceptedFiles: "File accettati",
    maxSize: "Dimensione max 16mb",
    title: "CARICA NUOVI DOCUMENTI",
    selectedDocuments: "Documenti selezionati",
    mainData: "DATI PRINCIPALI",
    comments: "Commenti",
    confirm: "Conferma upload",
    feedback: {
      success:
        "{total} documenti caricati con successo! Tra qualche minuto li troverai nella sezione documenti. Continua con altri upload oppure vai alla sezione Documenti.",
      noPermissions:
        "Il caricamento non è andato a buon fine! Non hai i permessi per caricare file in formato xml, contatta l’assistenza per maggiori informazioni.",
      genericError: "Si è verificato un errore nel caricamento. Controlla i file e ripeti l’upload. ",
      successUploaded: "caricati con successo e",
      inError: "in errore",
      goToDocuments: "Puoi andare alla sezione documenti per verificare oppure continuare con l'upload di altri documenti.",
    },
    optionalData: {
      crypt: {
        title: "Cripta documento",
        desc1: 'Se il tuo documento contiene dati sensibili e vuoi proteggerlo, seleziona l\'opzione "cripta documento".',
        desc2: "Cosa significa?",
        desc3: "Non potrai visualizzare l'anteprima del documento, sarà necessario effettuare il download del file per visualizzarlo.",
        desc4: "Ricorda che i documenti criptati non verranno indicizzati nella ricerca.",
      },
      onlyStudio: {
        title: "Visibile solo al tuo studio",
        desc1: "Selezionando questa opzione, il documento associato a questo cliente sarà visibile solo al tuo studio.",
        desc2: "Per renderlo visibile anche al cliente in un secondo momento, seleziona l’opzione nell’elenco documenti.",
      },
      toAccount: {
        title: "Da contabilizzare",
      },
    },
    widget: {
      title: "Trascina uno o più documenti",
      button: "Carica file",
    },
  },
  prelogin: {
    advertisingTitle: "<highlight>Collabora</highlight> con il tuo Studio in modo facile ed ecologico grazie alla Digital Box.",
    title: "Accedi o registrati al Portale TeamSystem",
    subtitle:
      "Condividi in modo veloce e sicuro i documenti, gestisci le scadenze e ottieni una panoramica completa sull’andamento dei tuoi clienti. Grazie al digitale riduci drasticamente il consumo di carta e gli spostamenti fisici; e il pianeta ringrazia!",
    copyright: "© 2025 TeamSystem S.p.A.",
    privacyPolicy: "Privacy Policy",
    cookie: "Cookie",
    thousands: "mila",
    managedCompanies: "Aziende gestite",
  },
  customersWidget: {
    title: "Clienti",
    showAllCustomers: "Guarda tutti i clienti",
    allCustomers: "Tutti i clienti",
    activeOnDigitalbox: "Attivo su Digital Box",
    activeDigitalbox: "Attiva subito Digital Box",
    awaitingDbx: "In attesa di accettazione...",
    piva: "p.iva: ",
    cf: "codice fiscale: ",
    company: "Azienda",
    user: "Privato",
    openPage: "Apri scheda cliente",
    noPermissions: "Non hai i permessi per visualizzare questa Azienda",
    activeDbxTooltip: "Cliccando qui, potrebbe essere necessario dover effettuare la login.",
    tsPayBanner: "Puoi importare automaticamente i movimenti bancari nel gestionale e riconciliarli con le operazioni contabili",
    checkupImpresaBanner:
      "La soluzione per monitorare costantemente l’equilibrio economico-finanziario delle aziende, visualizzare l’andamento del business, condividere gli indicatori di crisi.",
  },
  widgetTools: {
    active: "Attiva altri strumenti",
    tools: "Strumenti",
  },
  analytics: {
    noChartOnCompany: "Nessun grafico disponibile per l'azienda selezionata",
    cantSeeGraph: "Se non vedi questo grafico, controlla se l'Azienda può inviare dati verso TS Analytics",
    activateToSeeGraph: "Per vedere questo grafico connetti l'azienda alla Business performance",
    cashFlowModalTitle: "Saldo",
    cashFlowContent: "Aggiungi importi per calcolare il cash flow.",
    cashFlowPlaceHolder: "Per visualizzare il cash flow devi aggiornare il tuo saldo.",
    cashFlowUpgradeBalance: "Aggiorna saldo",
    currentAccountBalance: "Saldo conto corrente *",
    cashAndCashEquivalents: "Disponibilità liquide",
    or: "oppure",
    activeTsPay: "Attiva TS Pay",
    findOutTsPay: "Scopri TS Pay",
    viewCashFlow: "Visualizza Cash Flow",
    balance: "Saldo",
    lastUpdate: "Aggiornato il",
    attention: "Attenzione: ",
    visualizeBefore: "puoi visualizzare il cash flow per i prossimi 3 mesi dalla data odierna.",
    visualizeAfter: "Le previsioni del cash flow sono disponibili solo per i prossimi 3 mesi dalla data odierna.",
    goBack: "Torna indietro",
    selectMonth: "Seleziona il mese corrente.",
    businessPerformance: {
      modalTitle: "Informazione",
      modalDate: "Data dell'ultimo aggiornamento",
    },
  },
  creditsAndRevenues: {
    credits: "Crediti dello Studio",
    revenues: "Ricavi dello Studio",
    proforma: "Proforma",
    invoice: "Fattura",
    invoices: "Fatture",
    year: "anno",
    placeholdercredits: "Per visualizzare i crediti dello studio, attiva il modulo Gestione studio di Teamsystem Studio.",
    placeholderrevenues: "Per visualizzare i ricavi dello studio, attiva il modulo Gestione studio di Teamsystem Studio.",
  },
  obligations: {
    title: "Adempimenti",
    tabGeneral: {
      title: "Generale",
    },
    tabAccounting: {
      title: "Contabilità",
    },
    tabRevenues: {
      title: "Redditi",
    },
    tabWages: {
      title: "Paghe",
    },
    tabPayments: {
      title: "Versamenti",
    },
    tabSubstitute: {
      title: "Sostituti",
    },
    tabOther: {
      title: "Altri",
    },
  },
  checkup: {
    default1year: "Probabilità di default",
    netAssets: "Patrimonio netto",
    approach: "approccio",
    financialSustainability: "Sostenibilità degli oneri finanziari",
    capitalAdequacy: "Adeguatezza patrimoniale",
    liquidity: "Liquidità",
    liquidityReturn: "Ritorno liquido dell'attivo",
    socialDebt: "Indebitamento previdenziale e tributario",
    sectorIndices: "Indici di settore",
    crisisCompanies: "Aziende che presentano indizi di crisi",
    ratingCompanies: "Distribuzione aziende per rating",
    crisisIndex: "Indici della crisi",
    sectorsIndex: "Indici di settore",
    financialIndex: "Indicatori economico-finanziari",
    noAnalysisCrisis: "In questa sezione, a seguito dell’approvazione dell’analisi, ti verranno mostrate le aziende che presentano indizi di crisi.",
    noAnalysisRating:
      "In questa sezione, a seguito dell’approvazione delle analisi di Checkup d'impresa, ti verranno mostrate le aziende distribuite per rating.",
    noRating: "In questa sezione a seguito dell'approvazione delle analisi di Checkup d'impresa verranno mostrati i dati di Rating",
    noDSCR: "In questa sezione a seguito dell'approvazione delle analisi di Checkup d'impresa verranno mostrati i dati DSCR",
    noSectorsIndex: "In questa sezione a seguito dell'approvazione delle analisi di Checkup d'impresa verranno mostrati gli indici di settore",
    checkupBanner: "Attiva Check up d’impresa per  monitorare costantemente l’equilibrio economico-finanziario delle aziende",
    accountantBanner:
      "la soluzione per monitorare costantemente l’equilibrio economico-finanziario delle aziende, visualizzare l’andamento del business e condividere gli indicatori di crisi.",
    monitoringCompanies: "Tieni monitorate le aziende",
  },
  ask: {
    title: "Richieste",
    searchPlaceholder: "Cerca per titolo della richiesta",
    saveDraft: "Salva bozza",
    feedback: {
      ok1: "La tua richiesta",
      ok2: "è stata inviata",
      okTemplate1: "Il tuo modello",
      okTemplate2: "è stato pubblicato",
      ok2draft: "è salvata come bozza",
      button: "Torna a tutte le richieste",
      docTitle: "Documento aggiunto",
      docsTitle: "Documenti aggiunti",
      docDescription1: "Il file",
      docDescription2: "è stato aggiunto ai documenti.",
      docsDescription: "I file sono stati aggiunti ai documenti.",
      docHint: "Potrebbe volerci qualche secondo prima che sia visibile nella sezione",
    },
    header: {
      title1: "Crea richieste automatiche per ricevere documenti dai tuoi clienti",
      subtitle1: "Utilizza modelli già pronti o salva i tuoi personalizzati.",
      companyTitle1: "Quali documenti servono per le tue pratiche?",
      companySubtitle1:
        "Rispondi alle richieste inviate dal tuo consulente oppure invia direttamente la tua, scegliendo richieste pronte, per la documentazione riguardante mutui, finanziamenti, acquisto automobili e molto altro.",
    },
    widget: {
      showAll: "Mostra tutte le richieste",
      emptyWidget: "Attualmente non hai creato o ricevuto nessuna richiesta",
      toFill: "In attesa di risposta",
      toRead: "Da leggere",
      title: "Nuove richieste",
    },
    tooltips: {
      addNewAsk: "Crea una nuova richiesta",
      addNewAskCompany: "Invia una nuova richiesta",
    },
    pages: {
      answer: {
        uploadHint: "Solo XML, P7M, PDF, JPEG, JPG, PNG, DOC, DOCX, XLS, XLSX, CSV dimensione massima 16MB",
        createdAt: "Creata il",
        completedAt: "Completata il",
        noReply: "Nessuna risposta",
        title: "RICHIESTA",
        subtitle: "Compila i campi richiesti per inviare la documentazione al tuo consulente.",
        start: "Iniziamo!",
        compileFirst: "Compila la prima domanda di",
        good: "Sei a buon punto!",
        missingQuestions: "Mancano altre",
        questions: "domande",
        good2: "Ben fatto",
        youAre: "Sei all'",
        last: "ultima",
        question: "domanda",
      },
      list: {
        goBack: "Torna alla home",
        subtitle: "Filo diretto con il tuo commercialista",
        markAsRead: "Segna come letto",
        markAsUnread: "Segna come da leggere",
        all: "Tutte",
        toRead: "Da leggere",
        toSend: "Da inviare",
        draft: "Bozza",
        toFill: "Da compilare",
        notFilled: "Non compilata",
        filled: "Compilata",
        solicit: "Invia sollecito",
        solicited: "Sollecito",
        solicitAgain: "Reinvia sollecito",
        readResponse: "Leggi la risposta",
        open: "Apri",
        allCustomers: "Tutti i clienti",
        confirmDeleteTitle: "Conferma eliminazione",
        confirmDeleteSubtitle: "Confermi l'eliminazione del modello selezionato?",
        confirmDeleteSurveySubtitle: "Confermi l'eliminazione della richiesta selezionata?",
        chooseTemplate: "Scegli un modello",
        requestByStudio: "Richiesta dello studio",
        requestByClient: "Richiesta del cliente",
        myOwnRequest: "Mia richiesta",
        sendDate: "Data di invio",
        requestDate: "Data di invio",
        fillDate: "Data compilazione",
        solicitDate: "Data sollecito",
        requestCompleted: "Richiesta eliminata correttamente",
        requestError: "Si è verificato un errore durante l'eliminazione della bozza",
        error: "ERRORE",
      },
      edit: {
        title: "MODELLI",
        publishTemplate: "Pubblica modello",
        recipientsTip: "Per salvare un modello non è necessario selezionare un destinatario",
        back: "Torna alle richieste",
        orderBy: "Ordina per",
        lastPublish: "Ultime pubblicazioni",
        steps: {
          step1: "Inizio",
          step2: "Form",
          step3: "Destinatari",
          step4: "Invio",
        },
        chooseTemplate: {
          title: "I tuoi modelli",
          subtitle: "Scegli il modello per inviare una nuova richiesta",
          titleCompany: "Quale richiesta vuoi inviare?",
          subtitleCompany: "Scegli un modello",
          empty: "Vuoto",
          moreOn: "Mostra tutti",
          moreOff: "Nascondi",
          yourTemplatesTab: "I tuoi modelli",
          downloadedTemplatesTab: "Libreria modelli scaricati",
          toValidateTemplatesTab: "Modelli da validare",
        },
        communityTemplates: {
          title: "Modelli della Community",
          subtitle: "Scegli un modello tra quelli messi a disposizione da TeamSystem e dai tuoi colleghi",
          filterTitleCategory: "Categorie",
          placeholderCategory: "Tutte",
          filterTitleRating: "Rating",
          placeholderRating: "Tutti",
          filterTitleAuthors: "Autori",
          placeholderAuthors: "Scegli un autore",
          sorterTitleDate: "Data creazione",
          sorterTitlePrice: "Prezzo",
          templatePriceFree: "FREE",
          templateDownloads: "Downloads",
          templateDetailSubtitle: "Anteprima modello",
          templateDetailTitle: "Titolo della richiesta",
          templateDetailCategory: "Categoria",
          detailTemplatePageButton: "Salva modello nella tua libreria",
          detailTemplatePageGoToAuthorTemplates: "Guarda tutti i modelli di questo autore",
          dotsToggle: "Pubblica nello store della community",
          dotsToggleTooltip: "Rendi questo modello disponibile per la community. Potranno utilizzarlo e inviarlo in qualunque momento.",
          emptyList: "Spiacente, non ci sono modelli da mostrare.",
          downloadedTabSubtitle: "Scegli il modello per inviare una nuova richiesta",
          downloadedTabTitle: "Libreria download",
          saveDotsSuccessMessage: "Fatto! Seleziona il modello dalla tua libreria per iniziare a utillizarlo. ",
          saveDotsErrorMessage: "Si è verificato un errore durante il salvataggio del modello",
          saveDotsSuccessLink: " Vai alla libreria.",
          createAskDotsButton: "Crea richieste e modelli",
          createAskDotsButtonPlaceholder: "In questa sezione puoi creare una nuova richiesta o gestire i modelli",
          createAskDotsButtonTitlePlaceholder: "Modelli",
          noDownloadedDots: "Non ci sono ancora modelli scaricati.",
          sectionTitle: "Cerca un modello",
          searchPlaceholder: "Cerca con una parola chiave",
        },
        form: {
          title: "Titolo della richiesta",
          add: "Aggiungi una domanda",
          isShared: "Salva come modello",
          isSharedDesc: "Includi questo template nella lista dei tuoi modelli e potrai riutilizzarlo tutte le volte che vorrai.",
          isPublic: "Sempre a disposizione dei miei clienti",
          isPublicDesc:
            "Rendi questo modello disponibile per i tuoi clienti. Potranno compilarlo e inviarlo in qualunque momento, anche senza la tua richiesta.",
        },
      },
    },
    categories: {
      tax: "Fiscale",
      finance: "Finanza",
      social_security: "Previdenza/lavoro",
      accounting: "Contabilità",
      contract: "Contratti",
      corporate: "Societaria",
      tax_relief: "Agevolazioni",
      other: "Altro",
      all: "Tutti",
      Tutti: "Tutti",
    },
    builder: {
      question: "Domanda",
      info: "Informazioni aggiuntive",
      type: "Tipo di risposta",
      required: "Obbligatorio",
      tip: "Aggiungi indicazioni che aiutino a rispondere",
      multiplePlaceholder: "inserisci un'opzione",
      usersPlaceholder: "Cerca gli utenti a cui inviare la richiesta",
      deleteTitle: "Conferma eliminazione",
      deleteMessage: "Confermi l'eliminazione dell'elemento selezionato?",
      recipients: "Destinatari",
      previewTitle: "Anteprima della tua richiesta",
      cancelTitle: "Annulla le modifiche e torna all'inizio",
      cancelMessage: "Annullando perderai tutte le modifiche fatte finora. Sei sicuro di voler tornare indietro?",
      types: {
        text: "Testo semplice",
        date: "Data",
        currency: "Importo",
        number: "Numero",
        file: "File",
        yesno: "Si/No",
        multiple: "Multipla",
        single: "Singola",
      },
      feedback: {
        noQuestion: "La richiesta deve contenere almeno una domanda",
        noTitle: "Inserire il titolo della richiesta",
        noCategory: "Selezionare la categoria della richiesta",
        emptyQuestion: "Una delle domande inserite è vuota",
      },
    },
  },
  customerPage: {
    title: "SCHEDA CLIENTE",
    informations: "Informazioni: ",
    noAvailable: "non disponibili",
    registryWidget: {
      company: "Azienda",
      person: "Persona fisica",
      atecoCode: "Codice Ateco",
      multiCode: "Codice multis",
      tools: "Strumenti",
      cloudInvoices: "Fatture in cloud",
      bankTransactions: "Movimenti bancari",
      privacy: "Privacy",
      notAvailable: "Dato non disponibile",
      lastBankTransaction: "Ultimo Movimento bancario",
      lastPurchaseInvoice: "Ultima fattura di acquisto",
      lastSalesInvoice: "Ultima fattura di vendita",
      lastSumDue: "Ultimo corrispettivo",
      operation: "Operatività",
      obligations: "Adempimenti da inizio anno",
    },
    analyticsChart: {
      analyticsChart: "Titolo non disponibile",
      showAllBusinesssPerformance: "Guarda tutte le business performance",
    },
    landing: {
      noDataTitleUp: "Suggerisci la migliore strategia per il successo dei tuoi clienti",
      noDataSubTitleUp:
        "Aiuta i tuoi clienti a tenere sotto controllo l’andamento della loro attività e diventa il consulente di riferimento, controllando e condividendo i dati in tempo reale grazie a Business Performance.",
      titleMiddle: "Accedi ai dati dei tuoi clienti per offrire facilmente un servizio più completo",
      subTitleMiddle1: "Potenzia il controllo delle performance, integrando altri servizi Teamsystem.",
      subTitleMiddle2:
        "Se il tuo cliente utilizza un software TeamSystem per gestire la propria attività, può condividere con te le sue business performance (previo consenso) e le potrai consultare in tempo reale. Andamento del fatturato, cash flow, giacenze di magazzino e molto altro, sempre aggiornati grazie alle informazioni provenienti dai gestionali dei tuoi clienti.",
      collaborationTitle: "Collaboration con i clienti",
      collaborationSub:
        "Un nuovo paradigma operativo, basato sulla Digital Collaboration tra lo Studio e i suoi clienti: sei più vicino ai tuoi clienti e condividi con loro dati e informazioni in tempo reale.",
      graphKpiTitle: " Grafici e KPI aziendali",
      graphKpiSub:
        "Diventa un partner di business. I tuoi clienti possono condividere con te i dati sull'andamento della loro attività: fatturato, KPI di magazzino e molti altri, sempre aggiornati.",
      newServicesTitle: " Nuovi servizi",
      newServicesSub:
        "Accedi ai dati dei tuoi clienti in modo da supportarli al meglio nelle loro attività e arricchisci la tua offerta di servizi di consulenza.",
      noAuthTitle: "Business Performance",
      noAuthSub1: "Lo strumento per aiutare i tuoi clienti a tenere sotto controllo l’andamento della loro attività, condividendo i dati in tempo reale.",
      noAuthSub2:
        "Se non vedi le Business Performance è probabile che tu non abbia attivato il pacchetto per il tuo cliente. Se lo hai attivato, chiedi all’amministratore di attivare i permessi di visualizzare questi dati.",
      alertMsg1: "Perchè non vedi questi grafici?",
      alertMsg2: "Non hai i permessi per visualizzare questa sezione oppure non hai attivato Business Performance per questa Azienda.",
      connectionsButton: "Attiva Business Performance",
      activateBusinessPerformance: "Attiva gratuitamente Business Performance",
      buyPackage: "Acquista pacchetto",
      titleMiddleTSPay1: "Collaborazione ed efficienza.",
      titleMiddleTSPay2: "Ecco perchè attivare l’integrazione tra Digital Box e i servizi TS Pay.",
      subTitleMiddle1TSPay: "La collaborazione con i tuoi clienti non è mai stata così semplice e sicura.",
      subTitleMiddle2TSPay1:
        "Fornirai ai tuoi clienti uno strumento per disporre bonifici dalla Digital Box, evitando errori: i bonifici emessi da Digital Box hanno i dati di IBAN e importo già compilati. Riduci le attività necessarie per la registrazione degli incassi.",
      subTitleMiddle2TSPay2:
        "Le Aziende potranno importare i movimenti bancari in Digital Box per la riconciliazione bancaria delle scadenze. Tutti i movimenti riferiti a transazioni effettuate con TS Pay possono essere riconciliati automaticamente.",
      subTitleMiddle2TSPay3:
        "I dati sensibili di carte e conti correnti sono trattati in conformità alla normativa privacy vigente; i servizi di pagamento sono erogati da TeamSystem Payments S.r.l., autorizzata da Banca d’Italia a operare come istituto di pagamento.",
      doPaymentTitle: "Effettuare e ricevere pagamenti",
      reconciliationTitle: "Automatizzare la riconciliazione bancaria",
      cashFlowTitle: "Cash flow previsionale",
      doPaymentSub:
        "I tuoi clienti possono pagare la parcella dello Studio e i fornitori in modo semplice e veloce e richiedere ed effettuare pagamenti attraverso un semplice link.",
      reconciliationSub:
        "Grazie a TSPay i tuoi clienti potranno ridurre le attività necessarie per associare i movimenti bancari alle scadenze: è tutto automatico, dalla registrazione degli incassi alla riconciliazione.",
      cashFlowSub:
        "Grazie al collegamento con i conti dell’azienda, TS Pay incrocia i dati del saldo bancario con quelli di entrate e uscite, fornendo ai tuoi clienti un previsionale dei flussi di cassa dei prossimi 3 mesi.",
      contactUs: "Contattaci",
      noTSPayTitleUp: "PAGAMENTI SICURI PER I TUOI CLIENTI SENZA USCIRE DA DIGITAL BOX",
      noTSPaySubTitleUp:
        "TS Pay è il servizio che permette ai tuoi clienti di gestire incassi e pagamenti digitali, riconciliazione bancaria automatica e molto altro, all’interno di Digital Box.",
      bottomText: "Quali sono i vantaggi per i tuoi clienti?",
      tsPayAlertMsg1: "Attiva gratuitamente la connessione TS Pay per questo cliente!",
      tsPayAccountantAlertMsg1: "Consenso al collegamento del conto scaduto",
      tsPayConnectionsButton: "Connetti",
    },
    docsWidget: {
      inbox: "Inbox",
      noResults: "Nessun risultato",
      noDocuments: "Non ci sono documenti",
      noDocumentsUnread: "Non ci sono nuovi documenti da leggere",
      inviteUpload: "Vuoi caricarne uno ora?",
      daleggere: "Da leggere",
      documentsView: "Guarda tutti i documenti",
    },
  },
  dashboard: {
    title: "HOME",
    goBack: "Vai a Portale TS",
    incassaSubito: "Incassa Subito",
    showMore: "Scopri di più",
    noDisplay: "Non mostrare più",
    showVideo: "Guarda il video",
    goToIncassaSubito: "Vai a Incassa Subito",
    detail: "Visualizza il dettaglio",
    invoice: "Fatture elettroniche",
    noInvoices1: "Non ci sono nuove fatture elettroniche",
    noInvoices2: "Quando ne riceverai potrai visualizzare qui le più recenti",
    noRecentInvoices: "Non ci sono fatture recenti",
    accountant: {
      subtitle: "Il mio studio",
      premium: "Servizio Premium",
    },
    clientsSection: {
      title: "Utenti dell'azienda",
      usersCta: "Guarda utenti",
      noUsersMessage: "Questa azienda non ha ancora utenti.",
    },
    tsPayOnboardingMsg1: "Grazie al tuo Studio puoi attivare gratuitamente TS Pay.",
    tsPayOnBoardingMsg1Studio: "Puoi attivare il servizio TsPay.",
    tsPayOnboardingStartedMsg1: "Attenzione, non hai completato la registrazione su TS Pay.",
    tsPayOnboardingMsg2: "Gestisci il flusso di pagamenti in modo facile e veloce.",
    tsPayConfirmedStatusMsg1: "Attenzione, per iniziare ad utilizzare TS Pay devi confermare la mail che hai ricevuto.",
    buttonTextTsPayOnboarding: "Attiva TS Pay",
    buttonTextTsPayOnboardingStarted: "Riprendi",
    buttonTextTsPayConfirmedStatus: "Ricevi di nuovo la mail",
    tsPayTsPayOnboardingBannerUpperText: " è il servizio che ti permette di gestire i pagamenti in modo facile e veloce",
    tsPayTsPayOnboardingBannerBottomText:
      "Scopri il servizio che ti permette di richiedere pagamenti con un link e saldare le scadenze senza uscire da Digital Box.",
    tsPayText: "TS Pay",
    tsPayTsPayOnboardingBannerLandingUpperText: "ENTRA NELLE TUE BANCHE CON DIGITAL BOX",
    tsPayTsPayOnboardingBannerLandingBottomText:
      "TS Pay è il servizio che ti permette di gestire incassi e pagamenti digitali, riconciliazione bancaria e molto altro, all’interno di Digital Box.",
    tsPayOnboardingBannerLandingBottomText2: "Collegati gratuitamente ai servizi TS Pay.",
    tsPayOnboardingLandingTitle: "Scopri i vantaggi dell’integrazione fra Digital Box e i servizi TS Pay.",
    tsPayOnboardingLandingP1: "La {collabText} con il professionista che ti segue non è mai stata così semplice e sicura.",
    tsPayOnboardingLandingP2:
      "Disponi i bonifici per pagare le fatture ai fornitori dalla Digital Box, evitando errori: i bonifici emessi da Digital Box hanno i dati di IBAN e importo già compilati.",
    tsPayOnboardingLandingP3: "Riduci fino all’80% del tempo e delle risorse delegando a TS Pay tutta l’operatività di gestione e registrazione del pagamento.",
    tsPayOnboardingLandingP4:
      "Tutti i dati sensibili di carte e conti correnti sono trattati secondo i più alti standard di sicurezza; tutti i servizi di TeamSystem Payments sono vigilati da {bankText}.",
    tsPayOnboardingLandingCollabText: "collaborazione",
    tsPayOnboardingLandingBankText: "Banca d'Italia",
    tsPayOnboardingLandingFooterTitleText1: "Effettua e ricevi pagamenti",
    tsPayOnboardingLandingFooterTitleText2: "Automatizza la riconciliazione bancaria",
    tsPayOnboardingLandingFooterTitleText3: "Prevedi il cash flow",
    tsPayOnboardingLandingFooterP1:
      "Con TS Pay puoi saldare la parcella del tuo Commercialista in modo automatico e veloce, effettuare pagamenti digitali ai tuoi fornitori e richiedere pagamenti attraverso un semplice link.",
    tsPayOnboardingLandingFooterP2:
      "Riduci le attività necessarie per associare i movimenti bancari alle scadenze: è tutto automatico, dalla registrazione degli incassi alla riconciliazione.",
    tsPayOnboardingLandingFooterP3:
      "Grazie al collegamento con i tuoi conti, TS Pay incrocia i dati del tuo saldo bancario con quelli di entrate e uscite, fornendo un previsionale dei flussi di cassa dei prossimi 3 mesi.",
    tsPayResendOnboardingMailSuccess: "E-mail inviata con successo. Controlla tua casella di posta elettronica.",
    tsPayResendOnboardingMailError: "Spiacenti, il reinvio non è andato a buon fine. Per favore, riprova più tardi.",
    tsPayRetryErrorMessage: "Spiacenti, il processo non può essere portato avanti.",
  },
  accountingYear: {
    title: "Esercizi Contabili",
    previousBalance: "Saldo risultato esercizio precedente",
    yearDateTitle: "Anno",
    depreciationDateTitle: "Data Ammortamento",
    deferrals: "Risconti",
    createTitleFirst: "Ciao! Non hai ancora aperto un esercizio contabile per {companyName}.",
    createTitleSecond: "Aprilo subito, basta un minuto!",
    createDescription: "Inserisci i dati e crea il nuovo esercizio.",
    startLabel: "Data inizio esercizio *",
    endLabel: "Data fine esercizio *",
    createAccYearCta: "Crea nuovo esercizio",
    riscontiTitleActive: "Risconti attivi",
    riscontiTitlePassive: "Risconti passivi",
    table: {
      header: {
        year: "Anno",
        startDate: "Inizio esercizio",
        endDate: "Fine esercizio",
        useful: "Utile",
        closedOpened: "Chiusura/Apertura",
      },
      all: "Tutti",
      open: "Aperto",
      close: "Chiuso",
      select: "Seleziona",
      findDate: "Cerca data",
      empty: {
        title: "Nessun esercizio contabile",
        description: "Per il filtro selezionato",
      },
    },
    drawer: {
      title: "OPERAZIONI DI CHIUSURA",
      deposits: "RISCONTI",
      depreciation: "AMMORTAMENTI",
      total: "tot.",
      totalPrepaidExpenses: "tot. Risconti attivi",
      totalDeferredIncome: "tot. Risconti passivi",
      destina: {
        title: "DESTINA UTILE",
        linkableBreadcrumb: "Chiusura d’esercizio",
        currentBreadcrumb: "Destina Utile",
        causal: "Causale",
        causalType: "Destinazione risultato di esercizio",
        registrationDate: "Data di registrazione",
        accountingAccount: "Conto contabile",
        operatingResult: "Risultato di esercizio",
        give: "Dare",
        have: "Avere",
        account: "Contabilizza",
        addAccount: "Aggiungi conto contabile",
      },
    },
    depreciationModal: {
      yetDepreciation: "Hai già generato l'ammortamento!",
      footerCta: "Genera Ammortamento",
      footerCancelCta: "Annulla Ammortamento",
    },
  },
  deadlines: {
    title: "Scadenze",
    widgetAccountantTitle: "Scadenze fiscali e previdenziali",
    addDeadline: "Aggiungi nuova scadenza",
    widgetTitle: "Prossime scadenze",
    myDeadlines: "Le mie scadenze",
    fiscalCode: " / c.f. ",
    goBack: "Torna alla home",
    noPermissionsGoBack: "Torna indietro",
    goClientList: "Torna alla scheda cliente",
    invoiceFrom: "Fattura ricevuta da ",
    invoiceTo: "Fattura emessa a ",
    showDetail: "Guarda il dettaglio",
    deadlineDate: "Data *",
    deadlineDateNew: "Data",
    deadlineDateColumn: "Data scadenza",
    deadlineStatus: "Stato",
    collect: "Incassare",
    pay: "Pagare",
    collected: "Incassata",
    to_be_collected: "Da incassare",
    rejected: "Rifiutato",
    amount: "Importo",
    amountEuro: "Importo (€)",
    amountNotValid: "Importo non valido",
    amountToCollect: "Importo da incassare",
    amountToPaid: "Importo da pagare",
    amountToPay: "Importo da pagare",
    residueText: "Residuo scadenza",
    unpaid: "Non pagato",
    paid: "Pagata",
    due: "Da pagare",
    failed: "Da pagare",
    tocollect: "Da incassare",
    authorized: "Autorizzato",
    notAuthorized: "Non autorizzato",
    compensation: "Compensazione",
    rebate: "Abbuono",
    hideDeadline: "Nascondi scadenza",
    showDeadline: "Rendi visibile in elenco",
    effective: "Effettive",
    customers: "Per quale azienda vuoi creare la richiesta?",
    insertCounterpart: "Inserire la controparte",
    suspended: "Sospesa",
    buttonTSPayMultiple: "Paga {amount} con TS Pay",
    balanceModalCopy: "Al momento non hai ancora nessun conto collegato. Procedi con l'aggiungi conto in basso.",
    linkedDocEmpty: "Non è presente nessun documento collegato alla scadenza.",
    // paymentOutcomePending: "La richiesta di pagamento con TS Pay è stata inviata al conto {accountNumber} di {bankAccountName} il {paymentDate}",
    paymentOutcomePending: "La richiesta di pagamento con TS Pay è stata inviata il {paymentDate}",
    paymentOutcomeDone: "La scadenza è stata saldata il {paymentDate} con",
    paymentOutcomeCharged: "La scadenza è stata incassata il {paymentDate} con",
    // paymentOutcomeFailed: "Il pagamento è stato rifiutato. Verifica il conto {accountNumber} di {bankAccountName}.",
    paymentOutcomeFailed: "Il pagamento è stato rifiutato. Verifica il tuo conto.",
    renewConsent: "Rinnova il consenso al collegamento del conto",
    availableBalance: "Saldo disponibile",
    consentExpired: "Consenso scaduto",
    addAccount: "Aggiungi un conto",
    addAccountTsPay: "Collega un conto corrente al servizio TS Pay",
    subTitleTsPayStudio: "Gestisci le scadenze dei tuoi clienti con le funzioni fusione scadenze, sospendi, e crea nuove scadenze personalizzate.",
    subTitleTsPayClient: "Tieni sotto controllo le scadenze, pianifica e paga con TSPay.",
    balance: "Saldo",
    amount: "Importo",
    accounts: "Conti",
    header: {
      titleAccountant: "Pianifica e controlla le scadenze dei tuoi clienti",
      titleClient1: "Pianifica e controlla",
      titleClient2: "tutte le tue",
      titleClient3: "scadenze",
      amount: "Saldo",
      subtitle: "Gestisci le scadenze dei tuoi clienti con le funzioni fusione scadenze, sospendi, e crea nuove scadenze personalizzate.",
      subtitlePay: "Tieni sotto controllo le scadenze, pianifica e paga con TSPay.",
    },
    export: {
      csv: {
        button: "Esporta CSV",
        title: "Esporta scadenze in formato CSV",
        download: "Scarica subito le {num} scadenze più recenti",
        email: "Inviami tutte le scadenze via email",
        tip: "In entrambi i casi, la lista è soggetta ai filtri di ricerca che hai impostato.",
      },
    },
    noPermissions: "Il dettaglio di questa scadenza non è disponibile. Per maggiori informazioni contatta il tuo consulente.",
    adviceAmountNotValid: "L'importo del pagamento non può superare quello della scadenza",
    adviceTransformation: "Le scadenze aggiornate sono all’interno del documento:",

    split: {
      advice: "Questa scadenza è stata frazionata in 2 o più parti.",
    },
    tooltips: {
      addNewDeadline: "Aggiungi nuova scadenza",
    },
    compensation: {
      describe: "compensazione",
      description3ko: "Le scadenze non sono state compensate per un errore imprevisto. Riprovare più tardi.",
    },
    merge: {
      buttonConfirm: "Raggruppa o compensa",
      buttonConfirmGroup: "Raggruppa",
      buttonConfirmCompensation: "Compensa",
      tooltipDisableButton: "Per attivare queste funzionalità, applica un filtro per descrizione o controparte ",
      buttonCancel: "Annulla",
      save: "Salva scadenza",
      disabledCheckbox: "E' possibile raggruppare soltanto scadenze di tipologia debiti o crediti, in stato da pagare o da incassare",
      disabledCheckboxForDifferentCompany: "Puoi selezionare le scadenze solo per la stessa azienda",
      titleMerge: "Raggruppa scadenze selezionate",
      titleCompensation: "Compensa scadenze selezionate",
      titleStep2: "Crea nuova scadenza",
      titleStep3: "Riepilogo scadenze",
      allDeadlines: "Vai a tutte le scadenze",
      residual: "Residuo",
      deadlineTotalAmount: "Totale scadenza",
      deadlineDateNew: "Data scadenza",
      deadlineDateCompensation: "Data della compensazione",
      step1: "Selezione",
      step1c: "Compensazione",
      step2: "Nuova scadenza",
      step3: "Fine",
      btnCompensation: "Compensa",
      description1: "Conferma le selezioni effettuate oppure annulla e ripeti l’operazione.",
      description2:
        "Crea una nuova scadenza in sostituzione di quelle selezionate. Le informazioni principali delle scadenze originarie saranno memorizzate nello storico.",
      description3: "La nuova scadenza è stata creata",
      description3Zero: "Le scadenze sono state compensate",
      description3ko: "Le scadenze non sono state raggruppate per un errore imprevisto. Riprovare più tardi.",
      placeholderDescription: "Inserire una descrizione per la nuova scadenza",
      placeholderPayment: "Seleziona il metodo di pagamento per la nuova scadenza",
    },
    reconciliation: {
      title: "Riconciliazione bancaria",
      filterTitle: "Filtra scadenze",
      searchCounterpart: "Cerca controparte",
      movementsBiggerHeader:
        "L'importo del movimento ({registeringAmountMovements} €) è superiore al totale delle scadenze associate ({totalAmountToCover} €).",
      deadlinesBiggerHeader:
        "L'importo della registrazione che si sta effettuando ({registeringAmountDeadlines} € del {deadlineDate}) non copre il totale di {totalAmountDeadlines} € delle scadenze selezionate.",
      reconciliationAlert: "Il movimento bancario non è più associato a questa scadenza",
      choice: "Scegli la scadenza da frazionare:",
      choiceRebate: "Scegli la scadenza da cui scalare il residuo da abbuonare:",
      invalidSelectionDeadlines: "Attenzione, le scadenze che hai selezionato non corrispondono al movimento.",
      invalidSelectionDeadlinesDescription: "Per favore controlla di aver effettuato la scelta corretta.",
      reconciledSummaryText: "Hai {movementsNum} movimenti riconciliati e {notReconcilableNum} non riconciliabili {toRegisterString}",
      reconciledSummaryCta: "Contabilizza ora",
      registrationAllCta: "Contabilizza tutti",
      registrationSelectedCta: "Contabilizza selezionati",
      selectAllCta: "Seleziona tutti",
      deselectAllCta: "Deseleziona tutti",
      closeCta: "Chiudi",
      showOtherMovements: "Visualizza altri movimenti",
      hideOtherMovements: "Nascondi movimenti",
      registration: {
        accountingReason: "Causale contabile",
        accountingAccount: "Conto contabile",
        debit: "Dare",
        credit: "Avere",
        debitSuppliers: "Debiti v/fornitori",
        bank: "Banca",
        accountCta: "Contabilizza",
        payment: "Pagamento",
        receipt: "Incasso",
      },
    },
    payment: {
      /** si è deciso a passare da MPxx a PMxx per distinguere dai pagamenti fattura di origine */
      PMXA: "Compensazione",
      PM01: "Contanti",
      PM02: "Assegno",
      PM03: "Assegno circolare",
      PM04: "Contanti presso Tesoreria",
      PM05: "Bonifico",
      PM06: "Vaglia cambiario",
      PM07: "Bollettino bancario o postale",
      PM08: "Carta di pagamento",
      PM09: "RID",
      PM12: "RIBA",
      PM13: "MAV",
      PM14: "Quietanza erario",
      PM15: "Giroconto su conti di contabilità speciale",
      PM16: "Domiciliazione bancaria o postale",
      PM19: "SEPA",
      PM22: "Trattenuta su somme già riscosse",
      PM23: "PagoPA",
      PMXC: "Addebito su c/c",
    },
    frequency: {
      P1W: "Ogni settimana",
      P2W: "Ogni due settimane",
      P1M: "Ogni mese",
      P2M: "Ogni due mesi",
      P3M: "Ogni tre mesi",
      P4M: "Ogni quattro mesi",
      P6M: "Ogni sei mesi",
      P1Y: "Ogni anno",
    },
    widget: {
      taxRegime: "Regime fiscale",
      showAll: "Tutte le scadenze",
      customer: "Cliente ",
      customers: "Clienti ",
      noDeadlines: "Non ci sono prossime scadenze!",
      noDeadlinesAccountant: "Nessuna scadenza fiscale e previdenziale",
    },
    pages: {
      calendar: {
        other: "Altre ",
        monthView: "Torna alla vista mensile",
        noDataWithFilters: "Non ci sono scadenze con i filtri selezionati",
      },
      table: {
        irpef: "IRPEF",
        irap: "IRAP",
        ires: "IRES",
        imu: "IMU",
        tasi: "TASI",
        ivs: "IVS",
        f24: "F24",
        f23: "F23",
        ivaDownPayment: "Acconto IVA",
        ivaPayment: "Pagamento IVA",
        fiscalSocialSecurity: "Fiscali e previdenziali",
        credit: "Crediti",
        debt: "Debiti",
        rent: "Affitto",
        insurance: "Assicurazioni",
        studioReminder: "Promemoria studio",
        car: "Automobile",
        financing: "Finanziamento",
        recurring_fees: "Canone periodico",
        itemPays: "Cliente",
        managerPays: "Delega a Studio",
        managerCharge: "Delega a Studio su c/c del Cliente",
        itemCollect: "A favore del cliente",
        notPaid: "Non pagato",
        due: "Da pagare",
        buttonPaymentsAndCollects: "Incassi e pagamenti",
        pending: "In pagamento",
        tspay_paying: "In pagamento con TS Pay",
        toCash: "Da incassare",
        rebated: "Abbuonato",
        suspended: "Sospesa",
        archived: "Archiviata",
        RF01: "Ordinario",
        RF02: "Contribuenti minimi",
        RF03: "Nuove iniziative produttive",
        RF04: "Agricoltura e attività connesse e pesca",
        RF05: "Vendita sali e tabacchi",
        RF06: "Commercio fiammiferi",
        RF07: "Editoria",
        RF08: "Gestione servizi telefonia pubblica",
        RF09: "Rivendita documenti di trasporto pubblico e di sosta",
        RF10: "Intrattenimenti, giochi e altre attività di cui alla tariffa allegata al DPR 640/72",
        RF11: "Agenzie viaggi e turismo",
        RF12: "Agriturismo",
        RF13: "Vendite a domicilio",
        RF14: "Rivendita beni usati, oggetti d’arte, d’antiquariato o da collezione",
        RF15: "Agenzie di vendite all’asta di oggetti d’arte, antiquariato o da collezione",
        RF16: "IVA per cassa P.A.",
        RF17: "IVA per cassa",
        RF18: "Altro",
        RF19: "Regime forfettario",
        company: "Azienda",
        title: "Descrizione",
        paymentMinusDate: "Data di pagamento",
        paymentPlusDate: "Data di incasso",
        paymentTypePlus: "Modalità di incasso",
        paymentTypeMinus: "Modalità di pagamento",
        mode: "Modalità",
        handle: "Gestione",
        delegation: "Delega a Studio",
        counterpart: "Controparte",
        status: "Stato",
        viewed: "Letto",
        noResults: "Nessun risultato",
        solicitDeadline: "Sollecita scadenza",
        verifiedPaymentPaid: "Pagamento verificato: pagato",
        verifiedPaymentNotPaid: "Pagamento verificato: non pagato",
        solicitConfirmTitle1: "Confermando, invierai una notifica automatica all’azienda ",
        solicitConfirmTitle2: " per ricordargli questa scadenza.",
        solicitConfirmHide: "Non visualizzare più richiesta di conferma",
        settings: "Impostazioni",
        usersSettings: "Permessi utente",
      },
      create: {
        typeOfFrequency: "Quale tipo di scadenza vuoi creare? *",
        type: "Scegli il tipo di scadenza",
        startDate: "Data inizio *",
        finalDate: "Data fine *",
        frequency: "La scadenza si ripete",
        deadlinesPreview: "Guarda anteprima scadenze",
        previewText1: "Anteprima delle ",
        previewText2: " scadenze della serie",
        payment: "Pagamento",
        details: "Dettagli",
        goBack: "Vai a scadenze",
        title: "CREA SCADENZA",
        save: "Crea scadenza",
        amount: "Importo",
        amountDeadlines: "Importo scadenza",
        amountRata: "Importo rata",
        deadlineType: "In quale ambito vuoi creare la scadenza? *",
        deadlineCounterpart: "Nome e cognome o ragione sociale *",
        counterpartPlaceholder: "Inserisci il nome o la Ragione Sociale della controparte",
        fiscalCodePlaceholder: "Inserisci il Codice Fiscale della controparte",
        deadlinePIVAPlaceholder: "Inserisci la Partita IVA della controparte",
        companySelect: "Seleziona un cliente",
        companyList1: "Crea una nuova scadenza per ",
        companyList2: " I campi con l'asterisco (*) sono obbligatori.",
        single: "Singola",
        recurring: "Ricorrente",
        fiscalCode: "Codice Fiscale *",
        savingTitle1: "Salvataggio in corso.",
        savingTitle2: "Si prega di attendere.",
        saveModalError1: "Per salvare la scadenza è necessario inserire il ",
        saveModalError2: " oppure la ",
        saveModalError3: " della Controparte.",
      },
      detail: {
        repeats: "Si ripete",
        until: " fino al ",
        confirmAuthorization: "Conferma autorizzazione",
        authorizeDialogText1: "Se autorizzi lo Studio ",
        authorizeDialogText2: " ad effettuare il pagamento, verrà addebitato l'importo di ",
        authorizeDialogText3: " sul c/c ",
        authorizeDialogText4: " dello Studio",
        confirmQuestion: "Confermi?",
        authorize: "Autorizza",
        dontAuthorize: "Non autorizzare",
        dontAuthorizePayment: "Non autorizzare il pagamento",
        reject: "Rifiuta",
        notAuthorizedDialogText1: "Se non autorizzi lo Studio ",
        notAuthorizedDialogText2: " ad effettuare il pagamento, rischi di incorrere in sanzioni.",
        notAuthorizedDialogText3: "Sei sicuro di voler rifiutare l’autorizzazione?",
        confirmRejection: "Conferma rifiuto pagamento",
        addNote: "Vuoi aggiungere un commento?",
        saveNote: "Salva commento",
        refuseMessage1: "Se rifiuti di effettuare il pagamento, rischi di incorrere in sanzioni.",
        refuseMessage2: "Se confermi, il tuo Studio ",
        refuseMessage3: " verrà avvisato.",
        refuseMessage4: "Sei sicuro di non voler pagare questa scadenza?",
        addStudioComment: "Aggiungi un commento per lo studio",
        registerPayment: "Registra pagamento",
        registerPaymentWithTsPay: "Paga con bonifico bancario",
        registerPaymentWithTsPay2: "Paga con",
        limitTipTsPayPayment: "con Ts Pay puoi pagare importi fino a {limit}",
        sendTsPayMail: "Richiedi pagamento con",
        registerCollect: "Registra incasso",
        newDeadlineResidue: "Crea nuova scadenza",
        dontPay: "Non pagare",
        suspend: "Sospendi",
        active: "Riattiva la scadenza",
        register: "Registra",
        registerSuccess: "Pagamento registrato con successo",
        paymentDate: "Data pagamento",
        saleDate: "Data incasso",
        deadlineDate: "Data scadenza",
        registerPaymentAmountZero: "Inserire l'importo maggiore di 0",
        registerPaymentDifferentToZero: "Inserire l'importo diverso da 0",
        registerIsSplitting: "Creazione nuova scadenza da residuo in corso.",
        paymentType: "Modalità di pagamento",
        hiddenDeadline: "Scadenza nascosta",
        visibleDeadline: "Ora la tua scadenza è visibile in elenco",
        collected: "Riscosso",
        toCollect: "Da incassare",
        reconciledDeadline: "Scadenza riconciliata",
        itemPaysSentence1: "L’importo può essere versato esclusivamente tramite i servizi telematici dell’Agenzia delle Entrate.",
        itemPaysSentence2: "L’importo può essere versato tramite i servizi telematici dell’Agenzia delle Entrate o i servizi di internet banking",
        managerPaysSentence1: "L’importo verrà pagato, come da autorizzazione del cliente, direttamente dallo studio.",
        managerPaysSentence2: "L’importo verrà pagato, come da vostra autorizzazione, direttamente dallo studio.",
        managerChargeSentence1: "L’importo verrà addebitato, come da autorizzazione del cliente, direttamente ",
        managerChargeSentence2_1: "sul c/c con codice IBAN ",
        managerChargeSentence2_2: "sul suo c/c",
        managerChargeSentence3: "L’importo verrà addebitato, come da vostra autorizzazione, ",
        modifiedDate: "Modificato il ",
        totalDeadlinesAt: "Totale scadenze del ",
        hiddenDeadlineDetail:
          "Potrai ripristinare la scadenza in seguito da questa icona. Puoi visualizzare le scadenze nascoste dal calendario, attivando l'opzione visualizza scadenze nascoste.",
        paidOffDeadline1: "La scadenza è stata saldata ",
        paidOffDeadlineDeterminative: "il ",
        paidOffDeadline2: " con ",
        rejectedPayment: "Il pagamento è stato rifiutato il ",
        reminderSent: "Hai inviato un sollecito: ",
        showMore: "Mostra più",
        showLess: "Mostra meno",
        tab1: "Dettagli",
        tab2: "Commenti",
        tspay: {
          title: "Paga con TS Pay",
          stepper1: "Il tuo conto",
          stepper2: "Beneficiario",
          stepper3: "Paga",
          warnings: {
            account: "Seleziona un conto per il pagamento della scadenza",
            name: "Inserisci il nome del beneficiario",
            iban: "Inserisci l'iban del beneficiario",
            date: "Inserisci la data di pagamento",
          },
          payment: {
            mainbox: {
              title: "Dati del pagamento",
            },
            sidebox: {
              title: "Riepilogo",
            },
          },
          content1: {
            title: "Stai pagando le scadenze selezionate",
            amount: "Importo totale",
            accounts: "Seleziona conto",
            noAccounts: "Nessun conto trovato",
            insufficient: "Disponibilità insufficiente",
          },
          content2: {
            name: "Nome e Cognome beneficiario",
            iban: "IBAN",
            date: "Data pagamento",
          },
          content3: {
            summary: "Riepilogo pagamento",
          },
          content4: {
            feedback: "Pagamento registrato con successo",
          },
        },
      },
    },
    table: {
      deadlineDate: "Data scadenza",
      company: "Azienda",
      counterpart: "Controparte",
      description: "Descrizione",
      amount: "Importo",
      paymentMode: "Modalità di pagamento",
      management: "Gestione",
      status: "Stato",
      isRead: "Letto",
      planned: "Pianificate",
      hidden: "Nascoste",
      onlyHidden: "Solo scadute",
      allAreas: "Tutti gli ambiti",
      total: "Totale",
      deadlines: "scadenze",
      deadline: "scadenza",
      otherPlanned: "{total} scadenze pianificate",
    },
  },
  documents: {
    title: "DOCUMENTI",
    showMore: "Visualizza altri risultati",
    noDocuments_1: "Per",
    noDocuments_2: "non ci sono ancora documenti",
    noResults_1: "Spiacente, non ho trovato risultati per",
    noResults_2: "Riprova con un altro termine di ricerca",
    noResults_filtered: "Nessun documento per il filtro selezionato",
    searchLabel: "Cosa stai cercando oggi",
    searchPlaceholder:
      "Cerca per parola chiave, categoria, data, tipo di documento, cliente, numero fattura, importo e molto altro. Inserisci almeno 3 caratteri.",
    upload: "Carica un nuovo documento",
    onlyUnread: "Solo non letti",
    linkedTo: "Documento collegato a",
    preview: {
      placeholder: "Modello grafico:",
      previewDoc: "Anteprima documento",
      xml: "Anteprima XML",
      ae: "Anteprima Agenzia delle entrate",
    },
    filters: {
      cancel: "Cancella filtri",
      date: "Data",
      filterFor: "Filtra per",
      others: "Altri filtri",
      selectPeriod: "Seleziona periodo",
      invoiceTypology: "Tipologia fattura",
      selectMonths: "Seleziona mesi",
      month: "Mese",
      quarter: "Trimestre",
      semester: "Semestre",
      fromDate: "Data inizio",
      toDate: "Data fine",
      typeDate: {
        documentLess: "Data documento meno recente",
        createLess: "Caricamento meno recente",
        documentMore: "Data documento più recente",
        createMore: "Caricamento più recente",
        importLess: "Importo più basso",
        importMore: "Importo più alto",
        document: "Documento",
        create: "Caricamento",
        order: "Ordina per",
        scoreLess: "Corrispondenza maggiore",
        scoreMore: "Corrispondenza minore",
      },
    },
    detail: {
      title: "ANTEPRIMA DOCUMENTO",
      classificator: "Cambia classificazione",
      visibleByStudioOnly: "Visibile solo al tuo studio",
      visibleByAll: "Visibile a tutti",
      tab1: "Dettaglio",
      tab2: "Commenti",
      attachmentSectionTitle: "Allegati",
      linkedDocumentsSectionTitle: "Documenti collegati",
      manage: "Gestisci",
      linkedDocModalTitle: "Collega documenti",
      linkedDocModalCancelButton: "Annulla",
      linkedDocModalSaveButton: "Salva",
      linkedDocEmpty: "Non è presente nessun documento collegato, al momento.",
      attachmentEmpty: "Non è presente nessun allegato, al momento.",
      accuracy: "Corrispondenza",
      infoSectionTitle: "Informazioni",
      nameSectionTitle: "Nome file",
      originalName: "Nome originario",
      errorTitle: "Impossibile rinominare",
      errorMessageNoCharacter: "Il nuovo nome del file deve contenere almeno un nuovo carattere.",
      errorMessageInternalServerError: "Spiacenti, il processo non è andato a buon fine. Per favore, riprovare più tardi.",
      errorMessageDifferentFilename: "Il nome del file deve essere diverso dal nome corrente.",
      nameInputPlaceholder: "Inserisci il nome del fil",
      status: "Stato",
      otherSectionTitle: "Altro",
      modifyDeadlines: "Gestione scadenza",
      uploader: "Caricato da",
      folder: "Aggiungi a fascicolo",
      recipientDeliveryDate: "Consegnata al destinatario",
      recipientAvailableDate: "Messa a disposizione del destinatario",
      receiptDate: "Ricevuta dallo SDI",
      sdiDeliveryDate: "Consegnata allo SDI",
      paRejected: "Rifiutata dal destinatario",
      paEffectiveDate: "Fattura regolarmente emessa per decorrenza dei termini",
      paAccepted: "Accettata dal destinatario",
      inputPlaceholder: "Inserisci il nome del documento",
      toFolder: "a fascicolo",
    },
    tooltips: {
      addNewDocument: "Aggiungi nuovo documento",
    },
    headerTitle: {
      firstPart: "Tutti i tuoi documenti",
      boldPart: "in un unico posto",
      secondPart: "sempre in ordine.",
    },
    headerSubtitle: {
      boldPart: "Trova i tuoi documenti",
      secondPart: "navigando attraverso le macrocategorie, filtra con i tag, con la selezione temporanea oppure fai una ricerca testuale con parole chiave.",
      bisPart: "Se non trovi quello di cui hai bisogno, ",
      bisLinkPart: "Acquista un documento",
    },
    dictionary: {
      macrocategory: "Categoria",
      microcategory: "Sotto categoria",
      category: "Descrizione",
      ditta_cf: "Codice fiscale azienda",
      ditta_nome: "Nome azienda",
      ditta_denominazione: "Denominazione azienda",
      ditta_piva: "Partita Iva azienda",
      fiscale_periodo_al: "Data finale di riferimento",
      idobject: "ID knos di pubblicazione",
      info_file: "Nome file",
      time_stamp: "Timestamp",
      utente_nome: "Utente",
      documento_tipo: "Descrizione",
      fiscale_periodo_anno: "Periodo anno fiscale",
      trasmesso_cod: "Trasmesso codice",
      protocollo_attribuito: "Protocollo attribuito",
      progressivo_invio: "",
      esito: "Esito",
      file: "Nome file",
      ambiente: "Ambiente",
      ditta_codice: "Ditta codice",
      data_ricezione: "Data ricezione",
      doc_codice: "Codice documento",
      doc_subcodice: "Sottocodice documento",
      doc_descrizione: "Descrizione documento",
      fiscale_periodo_dal: "Periodo fiscale di partenza",
      start: "inizio",
      cod_au: "Codice anagrafica unica",
      id_anagrafica: "Id anagrafica",
      cf_intermediario: "Codice fiscale intermediario",
      fiscale_data_vers: "Data di versamento",
      fiscale_periodo_periodo: "Anno di riferimento",
      fiscale_data_doc: "Data documento",
      doc_numero: "Numero documento",
      doc_serie: "Codice sezionale registro iva",
      doc_serie_descrizione: "Descrizione sezionale registro iva",
      "documento.tipo": "Descrizione",
      progre: "Progressivo documento",
      cod_cli: "Codice cliente",
      cliente: "Denominazione cliente",
      descrizione_cli: "Descrizione aggiuntiva cliente",
      piva_cli: "Partita iva cliente",
      cfis_cli: "Codice fiscale cliente",
      cod_for: "Codice fornitore",
      fornitore: "Denominazione fornitore",
      descrizione_for: "Descrizione aggiuntiva fornitore",
      piva_for: "Partita iva fornitore",
      cfis_for: "Codice fiscale fornitore",
      trasmesso_nome: "Denominazione trasmittente",
      num_accolte: "Dichiarazioni accolte",
      num_pagamenti: "Numero pagamenti",
      num_scartate: "Numero scarti",
      num_trasmissioni: "Numero trasmissioni",
      vers_positivo: "Versamenti positivi",
      vers_zero: "Versamenti importo 0",
      utente_id: "Id utente",
      filiale_cod: "Codice filiale",
      filiale_desc: "Descrizione filiale",
      mat_inps_ditta: "Matricola INPS",
      mese_cod: "Numero mese",
      mese_desc: "Descrizione mese",
      mat_dip: "Matricola dipendente",
      cognome_nome_dip: "Cognome e nome dipendente",
      cod_fiscale_dip: "Codice fiscale dipendente",
      comune_dip: "Comune residenza dipendente",
      data_ass: "Data assunzione dipendente ",
      qualifica_cod: "Codice qualifica dipendente",
      qualifica_desc: "Descrizione qualifica dipendente",
      registro: "Codice registro",
      num_pag_i: "Pagina registro",
      annullato: "Contiene pagina annullata",
      pos_inail_ditta: "Posizione Inail azienda",
      data_cess: "Data cessazione dipendente",
      cod_centro_costo: "Codice centro di costo",
      centro_costo: "Descrizione centro di costo",
      cod_reparto: "Codice centro di reparto",
      "status.name": "Stato",
      lynfa: "Ts Studio",
      "dati riepilogo.0.imponibile importo": "Riepilogo dati riga 1 Imponibile Importo",
      "dati riepilogo.0.imposta": "Riepilogo dati riga 1 imposta",
      "dati riepilogo.0.arrotondamento": "Riepilogo dati riga 1 arrotondamento",
      "dati pagamento.0.condizioni pagamento": "Dati pagamento riga 1 condizioni pagamento",
      "dati pagamento.0.codice modalita pagamento": "Dati pagamento riga 1 codice modalita pagamento",
      "dati pagamento.0.modalita pagamento": "Dati pagamento riga 1 modalita pagamento",
      "dati pagamento.0.importo pagamento": "Dati pagamento riga 1 importo pagamento",
      importo: "Importo",
      provenienza: "Provenienza",
      anno: "Anno",
      dataversamento: "Data versamento",

      paginafinale: "Pagina finale",
      paginainiziale: "Pagina iniziale",
      periododiriferimento: "Periodo di riferimento",
      sezionale: "Sezionale",
      tipodichiarazione: "Tipo Dichiarazione",
      datadichiarazione: "Data Dichiarazione",
      denominazionesoggetto: "Denominazione Soggetto",
      codicefiscalesoggetto: "Codice Fiscale Soggetto",
      datainzio: "Data Inzio",
      numero: "Numero ",
      datadocumento: "Data documento",
      periododiriferimento: "Periodo di riferimento ",
      datadiscadenza: "Data di scadenza",
      denominazionedelcontraente: "Denominazione del contraente",
      codicefiscaledelcontraente: "Codice fiscale del contraente",
      partitaivadelcontraente: "Partita Iva del contraente",
      domicilio: "Domicilio",
      modalitàdipagamento: "Modalità di pagamento",
      targadelveicolo: "Targa del veicolo",
      tipodelveicolo: "Tipo del veicolo",
      classedimerito: "Classe di merito",
      perdiododiriferimento: "Perdiodo di riferimento",
      datascadenza: "Data Scadenza",
      idcomunicazione: "ID Comunicazione",
      codiceatto: "Codice Atto",
      datatrasmissionetelematica: "Data trasmissione telematica",
      codicefiscaledestinarario: "Codice Fiscale Destinarario",
      cognomedestinatario: "Cognome Destinatario",
      dataemissione: "Data emissione",
      denominazionedestinatario: "Denominazione Destinatario",
      idpaesedestinatario: "ID paese destinatario",
      importo: "Importo",
      nomedestinatario: "Nome Destinatario",
      numerodocumento: "Numero Documento",
      partitaivadestinatario: "Partita Iva Destinatario",
      codicefiscalefornitoremittente: "CodiceFiscale Fornitore (mittente)",
      cognomefornitoremittente: "Cognome Fornitore (mittente)",
      datadiregistrazione: "Data di registrazione",
      denominazionefornitoremittente: "Denominazione Fornitore (mittente)",
      idpaesefornitore: "ID paese fornitore",
      nomefornitoremittente: "Nome Fornitore (mittente)",
      partitaivafornitoremittente: "Partita iva Fornitore (mittente)",
      cognome: "Cognome",
      nome: "Nome",
      entecheharilasciatoildocumento: "Ente che ha rilasciato il documento",
      tipoformato: "Tipo Formato",
      matricola: "Matricola",
      sostitutodimposta: "Sostituto d'imposta",
      datatrasmissionetelematicadataditrasmissione: "Data trasmissione telematica / Data di trasmissione",
      descrizionedocumento: "Descrizione Documento",
      denominazionedeltrasportatore: "Denominazione del trasportatore",
      codicefiscaledeltrasportatore: "Codice fiscale del trasportatore",
      partitaivadeltrasportatore: "Partita Iva del trasportatore",
      denominazionecontroparte: "Denominazione Controparte",
      codicefiscalecontroparte: "Codice Fiscale Controparte",
      partitaivacontroparte: "Partita Iva Controparte",
      duratadelcontratto: "Durata del contratto",
      tipologiadicontratto: "Tipologia di contratto",
      oggettodelcontratto: "Oggetto del contratto",
      codiceidentificativo: "Codice Identificativo ",
      destinatariodeldocumentocomunicazione: "Destinatario del documento/ Comunicazione",
      iddocumentonelsistemadellamministrazione: "ID Documento nel sistema dell'Amministrazione",
      idfascicolonelsistemadellamministrazione: "ID Fascicolo nel sistema dell'Amministrazione",
      identificativoamministrazione: "Identificativo Amministrazione",
      identificativoaoo: "Identificativo AOO",
      mittentedeldocumentocomunicazione: "Mittente del documento/ Comunicazione",
      progressivoprotocollo: "Progressivo Protocollo",
      numerodiregistrazione: "Numero di registrazione",
      ufficiodiregistrazione: "Ufficio di registrazione",
      denominazione: "Denominazione ",
      codicefiscale: "Codice fiscale ",
      oggettodellaconvocazione: "Oggetto della convocazione",
      numeroregistrazione: "Numero Registrazione",
      cedentenazione: "Cedente Nazione",
      cedenteprovincia: "Cedente Provincia",
      datiriepilogo: "Dati Riepilogo",
      numeroprogressivoprogressivoinvio: "Numero Progressivo /Progressivo invio",
      stato: "Stato",
      dataconsegnamessaadisposizionealdestinatario: "Data Consegna/messa a disposizione al destinatario",
      codiceidentificativoclassificazione: "Codice Identificativo (classificazione)",
      cognomedellinteressato: "Cognome dell' Interessato",
      protocolloserviziotelematicodoganale: "Protocollo Servizio telematico doganale",
      soggettodelegato: "Soggetto delegato",
      soggettoobbligato: "Soggetto obbligato",
      datadellinventario: "Data dell'Inventario",
      tipodiinventario: "TIpo di Inventario",
      modalitaditrasmissione: "Modalità di trasmissione",
      ente: "Ente",
      controparte: "Controparte",
      codicedocumento: "Codice documento",
      eserciziofiscale: "Esercizio Fiscale",
      datadichiusuracreazione: "Data di chiusura (creazione)",
      idfilelog: "ID file log",
      idlog: "ID Log",
      improntahashdocumento: "Impronta (hash) documento",
      soggettoid: "Soggetto ID",
      utenteid: "Utente ID",
      casellapecmail: "Casella Pec/ Mail",
      datamessaggiopecmail: "Data Messaggio Pec/ mail",
      idmessaggiopecmail: "Id Messaggio Pec/mail",
      oggettomessaggiopecmail: "Oggetto messaggio Pec/ mail",
      tipologiacontratto: "Tipologia contratto",
      codicematricoladipendentetrasferta: "Codice matricola dipendente/trasferta",
      cognomedipendentetrasfertista: "Cognome dipendente trasfertista",
      nomedipendentetrasfertista: "Nome dipendente trasfertista",
      fideiussore: "Fideiussore",
      riferimentidocumento: "Riferimenti documento",
      riferimento: "Riferimento ",
      comune: "Comune",
      periododiimposta: "Periodo di imposta",
    },
    delete: {
      title: "Rimuovi questo documento",
      text: "Sei sicuro di voler rimuovere questo documento?",
      confirm: "Rimuovi documento",
      no: "No",
      feedback: {
        okTitle: "Documento correttamente rimosso",
        okMessage: "Non sarà più possibile accedere al documento cancellato",
        koTitle: "Si è verificato un errore",
        koMessage: "Non è stato possibile eliminare questo documento",
      },
    },
    classificator: {
      title: "CLASSIFICAZIONE DOCUMENTO",
      titlePage: "Classifica",
      step1: "Classificazione",
      step2: "Etichette",
      step3: "Salvataggio",
      back: "Torna alla sezione documenti",
      backAsk: "Torna al dettaglio della richiesta",
      tooltip1: "Se non trovi il tipo di documento che ti occorre, fai clic su",
      tooltip2: "HELP Supporto ",
      tooltip3: "e chiedi all'assistenza di aggiungere l'opzione che ti interessa",
      tags: {
        add: "Aggiungi etichette",
        custom: "Etichette Personalizzate",
        newName: "Digita il nome del nuovo tag",
      },
      feedback: {
        okTitle: "Cambio classificazione effettuato",
        okMessage: "Il cambio classificazione è stato effettuato",
      },
    },
  },
  folders: {
    title: "Fascicoli",
    titleCompany: "I miei fascicoli",
    folder: "Il fascicolo",
    create: "CREA NUOVO FASCICOLO",
    created: "è stato creato",
    edited: "è stato modificato",
    allfolders: "Torna a tutti i fascicoli",
    edit: "FASCICOLO",
    backTo: "Torna ai fascicoli",
    selection: "Seleziona un fascicolo a cui aggiungere questo documento.",
    loading: "Caricamento Fascicolo in corso. Si prega di attendere.",
    saving: "Salvataggio in corso. Si prega di attendere.",
    deleteConfirm: "Confermi l'eliminazione del fascicolo selezionato?",
    type: "Tipologia",
    refYear: "Periodo di riferimento",
    lastUpdate: "Ultimo aggiornamento",
    createdAt: "Data creazione",
    custom: "Personalizzato",
    contains: "Questo fascicolo contiene",
    onlyStudio: "Visibile solo al tuo studio",
    onlyStudioTooltip: "Se imposti il fascicolo come visibile solo al tuo studio il cliente non lo vedrà.",
    downloading1: "Download del fascicolo in corso.",
    tooltips: {
      addNewFolder: "Aggiungi nuovo fascicolo",
    },
    feedback: {
      delete: {
        ok: "Fascicolo eliminato con successo",
      },
    },
    typology: {
      Personalizzato: "Personalizzato",
      Banca: "Banca",
      Bilancio: "Bilancio",
      Dichiarazioni: "Dichiarazioni",
      Contenzioso: "Contenzioso",
    },
    toast: {
      warning: "Attenzione",
      noEmptyFields: "Compilare i campi obbligatori",
    },
    docCategories: {
      unSpecified: "Non specificato",
    },
    pages: {
      edit: {
        actions: {
          create: "Crea fascicolo",
          update: "Salva modifiche",
        },
        labels: {
          edit: "Fascicolo",
          create: "Crea Fascicolo",
          documents: "Documenti Fascicolo",
          name: "Nome fascicolo",
          type: "Tipologia",
          period: "Periodo di riferimento",
          attachments: "Documenti allegati",
        },
        types: {
          dossier_1: "Personalizzato",
        },
        summary: {
          title: "Stai creando questo fascicolo per",
        },
      },
      list: {
        filters: {
          text: "Cerca per nome o periodo di riferimento",
        },
        table: {
          cols: {
            name: "Nome fascicolo",
            type: "Tipologia",
            period: "Periodo rif. fascicolo",
            createdAt: "Data creazione",
            company: "Cliente",
          },
        },
      },
      create: {
        title: "Crea un nuovo fascicolo per",
        required: ". I campi con l'asterisco (*) sono obbligatori.",
      },
      delete: {
        confirm: "Conferma eliminazione",
      },
      share: {
        title: "Condividi questo fascicolo",
        description: "Condividi il link per il download del fascicolo",
        copy: "Copia link",
        copied: "Link copiato!",
        email: "Email",
        modalTitle: "Condividi fascicolo via e-mail",
        message: "Messaggio",
        placeholder: "Inserisci il testo facoltativo da aggiungere al messaggio",
        emailFeedback: "Email inviata con successo",
      },
    },
    header: {
      titleFirstPart: "Creare",
      boldTitle: "fascicoli",
      titleSecondPart: "in modo veloce e automatico è facilissimo!",
      subtitleFirstPart: "Seleziona",
      boldSubtitle: "aggiungi nuovo fascicolo",
      subtitleSecondPart: "e crea per tutti i tuoi clienti un dossier con la procedura guidata",
      companyTitle1: "I tuoi",
      companyTitle2: "fascicoli",
      companyTitle3: "sempre a portata di mano,",
      companyTitle4: "pronti da condividere.",
      companySubtitle1: "Trova subito i dossier di documenti preparati dal tuo consulente.",
    },
    widget: {
      folderDetail: {
        title: "Questo fascicolo contiene i seguenti documenti",
        noDocuments: "Nessun documento allegato al fascicolo",
      },
    },
    filters: {
      new: "Creazione più recente",
      old: "Creazione meno recente",
      update_new: "Aggiornamento più recente",
      update_old: "Aggiornamento meno recente",
      az: "A-Z",
      za: "Z-A",
    },
  },
  fulfilments: {
    title: "ADEMPIMENTI",
    headerTitle1: "Tieni sotto controllo lo stato dei tuoi ",
    headerTitle2: "adempimenti.",
    driverButton: "Definisci driver",
    searchFilter: "Cerca un cliente",
    dateFromFilter: "Da data",
    dateToFilter: "A data",
    editDialog: "Modifica adempimento",
    statuses: {
      completed: "Completato il {date}",
      todo: "Mancano {period}",
      expired: "Scaduto il {date}",
    },
    list: { addButton: "Aggiungi adempimento" },
    create: {
      titleLeft: "Seleziona adempimento",
      titleLeftManual: "Crea adempimento personalizzato",
      titleRight: "Seleziona Aziende",
      filters: {
        kinds: {
          accounting: "Contabili",
          fiscals: "Fiscali",
          management: "Gestione personale",
          all: "Tutti",
        },
      },
    },
  },
  generic: {
    all: "Tutti",
    cancel: "Annulla",
    back: "Indietro",
    next: "Avanti",
    save: "Salva",
    send: "Invia",
    export: "Esporta",
    total: "Totale",
    days: "Giorni",
    today: "Oggi",
    tomorrow: "Domani",
    completed: "Completati",
    undefined: "non definito",
    fiscalCode: "C.F.",
    fiscalCodeExtended: "Codice fiscale",
    fiscalCodeExtendedSmall: "codice fiscale",
    vatNumber: "P. IVA",
    vatNumberSmall: "p.iva",
    vatNumberExtended: "Partita IVA",
    balance: "Saldo",
    update: "Aggiorna",
    businessName: "Ragione sociale",
    address: "Indirizzo",
    notAvailable: "Non disponibile",
    select: "Seleziona",
    requiredField: "Campo obbligatorio",
    title: "Titolo",
    titlePlaceholder: "Inserire un titolo",
    titlePlaceholder3char: "Inserisci almeno 3 lettere",
    description: "Descrizione",
    descriptionNotAvailable: "Descrizione non disponibile",
    textPlaceholder: "Inserisci un testo",
    summary: "Riepilogo",
    firstName: "Nome",
    lastName: "Cognome",
    email: "email",
    selectStudio: "Seleziona uno studio dalla lista in alto",
    selectCompanyPlaceholder: "Inserire nome Azienda o Codice Fiscale...",
    counterpart: "Controparte",
    menu: "menu",
    manageProfile: "Gestisci profilo",
    changeAccountant: "Cambia studio",
    appDownload: "Scarica App",
    logout: "Esci",
    goodMorning: "Buongiorno",
    active: "attivo",
    notActive: "non attivo",
    loadingMessage: "Caricamento in corso. Si prega di attendere.",
    loadingMessage2: "Recupero informazioni in corso.",
    loadingMessage3: "Si prega di attendere.",
    password: "password",
    request: "Richiesta",
    customer: "Cliente",
    status: "Stato",
    documentsData: "Dati documento",
    documentDate: "Data documento",
    documentNumber: "Numero documento",
    documentAmount: "Importo documento",
    counterpart: "Controparte",
    counterpartPIVA: "P.IVA",
    notifications: "Notifiche",
    notificationsSettings: "Impostazioni notifiche",
    first: "Primo",
    second: "Secondo",
    third: "Terzo",
    fourth: "Quarto",
    copy: "Copia",
    attention: "Attenzione",
    loading1: "Caricamento in corso.",
    loading2: "Si prega di attendere.",
    operation1: "Operazione in corso.",
    operation2: "Attendere prego...",
    saving1: "Salvataggio in corso.",
    goodMorning: "Buongiorno",
    goodEvening: "Buonasera",
    yes: "Sì",
    no: "No",
    active: "Activo",
    notActive: "No activo",
    fiscalCodeAbbreviation: "c.f.",
    consentYes: "Sì, acconsento",
    consentNo: "Non, non acconsento",
    loadingData1: "Caricamento dati in corso",
    loadingData2: "Si prega di attendere",
    noSearchCompany: "Nessuna azienda trovata",
    shortTaxIdentifier: "C.F.",
    dates: {
      send: "Data invio",
      fill: "Data compilazione",
      receive: "Data ricezione",
    },
    rangePicker: {
      shortcut: {
        lastYear: "Ultimo anno",
        lastMonth: "Mese",
        lastQuater: "Trimestre",
        lastDay: "Oggi",
      },
    },
    months: {
      "01": "Gennaio",
      "02": "Febbraio",
      "03": "Marzo",
      "04": "Aprile",
      "05": "Maggio",
      "06": "Giugno",
      "07": "Luglio",
      "08": "Agosto",
      "09": "Settembre",
      10: "Ottobre",
      11: "Novembre",
      12: "Dicembre",
    },
  },
  notification: {
    markAllAsRead: "Segna tutte come lette",
    removeAll: "Rimuovi tutte",
    settings: "Configura notifiche",
    loading: "Caricamento in corso",
    markAsUnread: "Segna come non letta",
    markAsRead: "Segna come letta",
    remove: "Rimuovi",
    noNotification: "Nessuna notifica",
    refreshNotificationSuggestion: "Per visualizzare nuove notifiche prova ad aggiornare la sezione",
    settingsDescription: "Imposta le tue preferenze per ricevere le notifiche Digital Box.",
    app: "App",
    email: "Email",
    newDocument: "Nuovo documento",
    newComment: "Nuovo commento",
    askResponse: "Risposta a una richiesta",
    deadlinesOperation: "Operazioni su scadenze",
    newAskReceived: "Nuova richiesta ricevuta",
  },
  profile: {
    title: "PROFILO",
    profile: "Profilo",
    professionalStudies: "Studi professionali",
    account: "Account utente",
    customers: "I tuoi clienti",
    noCustomers: "Non hai ancora clienti",
    unverified: "Completa il tuo profilo",
    personalArea: "Accedi all'area personale",
    addressUnregistered: "Indirizzo non registrato",
    yourAccountants: "I tuoi commercialisti",
    yourAccountant: "Il tuo commercialista",
    noAccountant: "Non hai nessun commercialista",
    types: {
      accountant: "Studio",
      company: "Azienda",
    },
    modifyRegistry: "Modifica anagrafica",
    modifyPassword: "Modifica password",
  },
  settings: {
    title: "IMPOSTAZIONI",
    permissions: "Permessi",
    edit: "Modifica",
    summary: "Riepilogo",
    tooManyCompanies: "Attenzione",
    tooManyCompaniesDescription: "In questa tabella sono visualizzate solo le prime 100 aziende. Per trovare le altre utilizza la ricerca.",
    searchPlaceholder: "Cerca per cognome, nome o email dell'utente",
    searchCompanyPlaceholder: "Cerca azienda per C.F., P.IVA o ragione sociale",
    company: "Azienda",
    companies: "Aziende",
    clients: "Aziende",
    accountant: "Utenti",
    users: "Utenti",
    surname: "Cognome",
    name: "Nome",
    email: "E-mail",
    usersCompany: "Utenti dell'azienda",
    popoverTitle1: "L'azienda",
    popoverTitle2: "può svolgere le seguenti attività",
    goToSettingsPage: "Vai alla pagina delle Impostazioni",
    businessPerformancePermissionsTitle: "Business Performance",
    manageBusinessPerformanceSettings: "Gestisci",
    businessPerformanceModalTitle: "Permessi Business Performance",
    businessPerformanceModalContentTitle: "Permessi sugli indicatori di Business Performance dell’azienda",
    businessPerformanceModalUserTitle1: "Permessi di ",
    businessPerformanceModalUserTitle2: " sugli indicatori di Business Performance dell'azienda ",
    applyPermissions: "Applica",
    resetPermissions: "Annulla",
    summaryTable: {
      canSeeTitle: "Possono vedere",
      canUploadTitle: "Possono caricare i documenti",
      canDoTitle: "Possono effettuare queste attività",
      bpClientsTitle: "Business Performance Clienti",
      bpProvidersTitle: "Business Performance Fornitori",
      bpPortfolioTitle: "Business Performance Portafoglio",
      bpStoreTitle: "Business Performance Magazzino",
    },
    businessPerformance: "Gestisci Business Performance",
    businessPerformanceSettings: {
      clientsTitle: "Clienti",
      providersTitle: "Fornitori",
      portfolioTitle: "Portafoglio",
      storeTitle: "Magazzino",
    },
    userPermissions: {
      canSeeTitle: "Può vedere",
      canUploadTitle: "Può caricare i documenti",
      canDoTitle: "Può effettuare queste attvità",
      userManagerTitle: "può vedere e svolgere le seguenti attività",
    },
    feedback: {
      success: {
        title: "Impostazioni salvate correttamente",
        message: "Le impostazioni sono state salvate correttamente",
      },
      error: {
        title: "Si è verificato un problema",
        message: "Le impostazioni non sono state salvate correttamente",
      },
    },
  },
  tspay: {
    payment: {
      mainbox: {
        title: "Dati del pagamento",
      },
      sidebox: {
        title: "Riepilogo",
        summaryTipSingle: "Stai pagando",
        summaryTipMultiple: "Stai pagando",
        summaryTipReason: "Causale",
        summaryTipBeneficiary: "A",
        summaryTipBeneficiaryIban: "IBAN",
        summaryTipDate: "Data di pagamento",
        summaryAmount: "Importo",
      },
      warnings: {
        minReason: "La causale deve contenere almeno 5 caratteri",
      },
    },
  },
  widgets: {
    documentBrowsing: {
      label: "Seleziona uno o più documenti {existing}",
      label2: "Allega un documento",
      linkedDocLabel: "Documenti*",
      placeholder: "Cerca documento da allegare",
      title: "Scegli il tipo di documento",
      info: {
        documents: "documenti",
        date: "del",
        type: "Tipo documento",
        noDocuments: "Nessun documento trovato",
      },
    },
    costs: {
      title: "Totale costi",
      title2: "da inizio anno",
    },
  },
  signature: {
    emptyDocs: "Non hai nessun documento in firma",
    noService: "Non hai ancora richiesto l’attivazione di questo servizio",
    subtitle1: "Se richiedi l’attivazione di ",
    subtitle2: ", potrai consentire ai tuoi clienti di firmare elettronicamente i documenti, ",
    subtitle3: "direttamente da TS Digital Box:  tutte le soluzioni di firma per ogni esigenza, assicurazione obbligatoria FEA ",
    subtitle4: "e conservazione a norma comprese.",
    title: "DA FIRMARE",
    back: "Torna ai documenti da firmare",
  },
  reconciliation: {
    title: "Incassi e pagamenti",
    actions: {
      linkToMovement: "Associa al movimento",
      saveAndLinkToMovement: "Salva e associa al movimento",
    },
    abbuonoDescription:
      "Stai registrando un abbuono di {residueValue} per la parte di movimento bancario che supera l'importo totale della/e scadenze selezionate ({value} al posto di {totalAmount}).",
    movements: {
      title: "Movimenti su",
      nodata: "Nessun movimento trovato. Prova a impostare i filtri diversamente",
      titles: {
        today: "Oggi",
        lastWeek: "Ultimi 7 giorni",
        lastMonth: "Ultimo mese",
      },
      dialogs: {
        linkedTo: {
          title: "Scadenze associate al movimento",
          tip: "Scadenze associate al movimento del {date} di {amount} per {description}",
        },
      },
    },
    deadlines: {
      title: "Scadenze",
      deadlineDate: "Da {movementType} entro il",
      scope: "Ambito *",
      create: "Crea scadenza dal residuo",
      cost: "Spesa",
      residueCost: "Il residuo corrisponde a una spesa per:",
      addExistingDeadline: "Aggiungi scadenza esistente",
      filter: "Applica filtri",
    },
    accounting: {
      pageTitle: "CONTABILIZZAZIONE MOVIMENTI",
    },
  },
  parties: {
    create: {
      title: "Nuovo contatto",
      loader: "Salvataggio contatto in corso...",
      paymentSubtitle: "Definisci se dividere le rate in percentuale o in frazioni",
      feedbackMessageSuccess: "Fatto! Contatto aggiunto correttamente.",
      feedbackMessageError: "Spiacente. C'è stato un errore nel salvataggio",
      feedbackDescriptionError: "Riprova più tardi",
    },
    edit: {
      feedbackMessageSuccess: "Fatto! Contatto modificato correttamente.",
      feedbackMessageError: "Spiacente. C'è stato un errore nel salvataggio delle modifiche",
      feedbackDescriptionError: "Riprova più tardi",
    },
    delete: {
      feedbackMessageSuccess: "Fatto! Contatto eliminato correttamente.",
      feedbackMessageError: "Spiacente. C'è stato un errore nell'eliminazione del contatto",
      feedbackDescriptionError: "Riprova più tardi",
    },
    noPartyFound: "Non sono presenti contatti corrispondenti a questa ricerca.",
    viewMoreButton: "Visualizza altri clienti",
    hideButton: "Nascondi clienti",
    installmentsError: "Il totale delle rate aggiunte deve essere uguale al 100%.",
    createNew: {
      pageTitle: "Nuovo contatto",
      searchDescription: "Ricerca tra aziende private e pubbliche amministrazioni",
      registryTabTitle: "Anagrafica",
      paymentPlansTabTitle: "Rapporti commerciali",
    },
    paymentMode: "Modalità di pagamento",
    paymentTime: "Termine di pagamento",
    paymentTitle: "Pagamento",
    payment: {
      MPXA: "Compensazione",
      MP01: "Contanti",
      MP02: "Assegno",
      MP03: "Assegno circolare",
      MP04: "Contanti presso Tesoreria",
      MP05: "Bonifico",
      MP06: "Vaglia cambiario",
      MP07: "Bollettino bancario o postale",
      MP08: "Carta di pagamento",
      MP09: "RID",
      MP12: "RIBA",
      MP13: "MAV",
      MP14: "Quietanza erario",
      MP15: "Giroconto su conti di contabilità speciale",
      MP16: "Domiciliazione bancaria o postale",
      MP19: "SEPA",
      MP22: "Trattenuta su somme già riscosse",
      MP23: "PagoPA",
      MPXC: "Addebito su c/c",
    },
  },
  reports: {
    resultNotFound: "Non sono presenti report per la ricerca effettuata!",
    downloadCsv: "Scarica in CSV",
    printPdf: "Stampa in PDF",
    balance: {
      kinds: {
        balanceSheet: {
          title: "Stato patrimoniale",
          creditTitle: "Passività",
          debitTitle: "Attività",
        },
        incomeStatement: {
          title: "Conto economico",
          creditTitle: "Ricavi",
          debitTitle: "Costi",
        },
      },
    },
    vat: {
      yearSelect: "Imposta l'anno di riferimento per visualizzare la liquidazione iva",
      yearRef: "Anno di riferimento*",
      yearSelectPlaceholder: "Seleziona l'anno",
      vatOnCredit: "IVA a credito",
      vatOnDebit: "IVA a debito",
      reopenPeriod: "Riapri periodo",
      multiActivity: {
        previousVatCredit: "Credito IVA periodo precedente",
        previousVatDebit: "Debito IVA periodo precedente",
        amountOnDebit: "Importo a debito",
        amountOnCredit: "Importo a credito",
        activity: "Attività",
      },
      VAT_ADVANCE_MONTHLY: "Acconto Iva mensile",
      ADVANCE_MONTHLY: "Acconto Iva mensile",
      ANNUAL: "Annuale",
      FIRST_QUARTER: "Primo Trimestre",
      SECOND_QUARTER: "Secondo Trimestre",
      THIRD_QUARTER: "Terzo Trimestre",
      VAT_ADVANCE_TRIMONTHLY: "Acconto Iva trimestrale",
      ADVANCE_QUARTERLY: "Acconto Ivatrimestrale",
      FOURTH_QUARTER: "Quarto Trimestre",
      activityDetail: {
        summary: "Riepilogo",
        detail: "Dettaglio",
        description: "Descrizione",
        rateExemption: "Aliquota/Esenzione",
        rateDescription: "Descrizione aliquota",
        taxable: "Imponibile",
        tax: "Imposta",
        nonDeductibleAmount: "Indetraibilità",
        total: "Totale",
        activitySummary: "Riepilogo attività",
        previousDebt: "Debito precedente (art. 27 2.c)",
        vatDeposit: "Acconto IVA dovuto",
        vatOn: "IVA su ",
        reportedDebt: "Debito da riportare (art. 27)",
      },
      aliquoteDetail: {
        reason: "Causale",
        registrationDate: "Data registrazione",
        docNumber: "N. documento",
        docDate: "Data documento",
        destination: "Destinazione",
        nonDeductibility: "Indetraibilità",
        vatCollectability: "Esigibilità IVA",
        SPLIT_PAYMENT: "Split payment",
        DEFERRED: "IVA differita",
        IMMEDIATE: "Immediata",
      },
      vatAmountCredit: "Acquisti",
      vatAmountDebit: "Vendite",
      PURCHASE: "acquisti",
      SALE: "vendite",
      RECEIPT: "corrispettivi",
      PURCHASE_NON_DETRAIBILE: "acquisti indetraibile",
      MARGINE_ORDINARIO_IMPREZIOSIMENTO: "margine Ordinario Impreziosimento",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0730: "IVA Detraibile Agricoltura Speciale 0730",
      ESONERO_SALE_AGRICOLO: "esonero Sale Agricolo",
      SALE_VAT_DST000: "-",
      ORDINARIO_PREVIOUS_CREDIT: "credito IVA precedente",
      ORDINARIO_PREVIOUS_DEBIT: "debito precedente (art.27 c.2)",
      MARGINE_ORDINARIO: "imposta a debito regime del margine",
      SPLIT_PAYMENT_SALE: "vendite split payment a carico committente",
      CREDITO_DI_COSTO_PREV: "credito di costo precedente",
      CREDITO_DI_COSTO_NEXT: "credito di costo da riportare",
      IVA_MARGINE_GLOBALE: "imposta a debito regime del margine",
      IVA_SU_CORRISP_MFR000: "IVA su Corrispettivi forfetari",
      IVA_SU_CORRISP_MFR001: "IVA su Corrispettivi forfetari",
      IVA_SU_CORRISP_MFR002: "IVA su Corrispettivi forfetari",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0200: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0400: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0600: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0640: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0730: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0750: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0765: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0795: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0830: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0850: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0880: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0950: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_1000: "IVA detraibile agricoltura speciale",
      IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_123: "IVA detraibile agricoltura speciale",
      SALE_SUBFORNITURA: "iva agevolata art. 74 c.5",
    },
    vatEntries: {
      title: "Imposta i filtri per visualizzare il registro IVA",
      yearRef: "Anno di riferimento",
      yearSelectPlaceholder: "Seleziona l'anno",
      periodRef: "Seleziona periodo",
      periodRefPlaceholder: "Scegli periodo",
      ANNUAL: "Tutti",
      JANUARY: "Gennaio",
      FEBRUARY: "Febbraio",
      MARCH: "Marzo",
      APRIL: "Aprile",
      MAY: "Maggio",
      JUNE: "Giugno",
      JULY: "Luglio",
      AUGUST: "Agosto",
      SEPTEMBER: "Settembre",
      OCTOBER: "Ottobre",
      NOVEMBER: "Novembre",
      DECEMBER: "Dicembre",
      businessRef: "Seleziona attività *",
      businessRefPlaceholder: "Scegli attività",
      typeRef: "Seleziona tipologia report IVA",
      typeRefPlaceholder: "Scegli tipologia",
      typeStarter: "Report IVA",
      clearFilters: "Pulisci i filtri",
      businessSummary: "Riepilogo attività",
      sectionalRef: "Scegli il sezionale *",
      sectionalRefPlaceholder: "Seleziona sezionale",
      table: {
        registrationDate: "Data registrazione",
        docType: "Tipo documento",
        vatType: "Tipologia IVA",
        docNumber: "Numero documento",
        docDate: "Data documento",
        customerOrSupplier: "Cliente/Fornitore",
        vatNumberOrTaxId: "P.IVA/C.F",
        aliquote: "Aliquota",
        taxable: "Imponibile",
        tax: "Imposta",
        taxEnums: {
          IVA4: "4%",
          IVA5: "5%",
          IVA22: "22%",
          IVA2: "2%",
          IVA0: "0%",
          ESC000: "0%",
          IVA10: "10%",
        },
        total: "Totale",
      },
    },
  },
  taxCredit: {
    title: "Crediti Fiscali",
  },
  preCog: {
    sections: {
      cespiti: {
        tooltip: "Vai a gestione cespiti",
      },
      ritenute: {
        tooltip: "Vai a gestione ritenute",
      },
      usedGoods: {
        tooltip: "Vai a gestione beni usati",
      },
    },
    draftStatusMessage: {
      DRAFT_ALREADY_ACCOUNTED: "La scrittura è già stata inviata in contabilità",
      REQUIRED_DOCUMENT_DATE: "Il campo Data documento non può essere vuoto",
      FAR_AHEAD_DOCUMENT_DATE: "La Data del documento deve essere precedente o uguale alla Data di registrazione",
      ACCOUNTING_LINES_SIZE: "La scrittura contabile deve avere almeno due conti.",
      REQUIRED_ACCOUNT_CODE: "Inserire conto contabile",
      BOTH_DEBIT_CREDIT: "Ogni conto contabile può essere movimentato o in dare o in avere.",
      FAR_AHEAD_START_PERIOD: "La data di Fine competenza non può essere vuota o antecedente a quella di Inizio competenza",
      REQUIRED_REGIME: "Ad ogni movimento deve essere associato un Regime",
      REQUIRED_EXEMPTION_NATURE: "Se % iva è pari a 0, scegliere la natura di esenzione",
      REQUIRED_ARTICLE_DESCRIPTION: "Non è possibile definire una % aliquota in questa registrazione",
      NOT_COMPATIBLE_REASON: "La causale contabile non è compatibile con il tipo di documento",
      REQUIRED_CURRENCY: "Il campo Valuta non può essere vuoto",
      REQUIRED_BUSINESS: "Il campo Attività non può essere vuoto",
      UNBALANCED_ENTRY: "Il totale Dare deve essere uguale al totale Avere",
      REQUIRED_ASSET_GROUP_KIND: "Il campo Gruppo e/o il campo Specie non possono essere vuoti ",
      REQUIRED_ASSET_SUBKIND: "Il campo Sottospecie non può essere vuoto",
      REQUIRED_ASSET_AVAILABILITY_DATE: "Il campo Data di disponibilità in anagrafica cespiti non può essere vuoto",
      REQUIRED_ASSET_TAX_DEPRECIATION: "Il campo Ammortamento fiscale non può essere vuoto",
      REQUIRED_ASSET_IRAP: "Il campo % IRAP deve essere compilato",
      UNNECESSARY_ASSET_IRAP: "Il campo % IRAP non deve essere compilato",
      REQUIRED_ASSET_STATUTORY_DEPRECIATION: "Il campo % di Ammortamento non può essere vuoto",
    },
    accountantContent: {
      registration: "Registrazione",
      receiptDate: "Ricezione",
      accountingReason: "Causale contabile",
      dataDoc: "Data documento",
      docNumber: "Numero documento",
      amount: "Importo",
      company: "Cliente/Fornitore",
      errorMessage: "Il dettaglio di questa registrazione non è disponibile.",
    },
    saveAndClose: "Salva e chiudi",
    close: "Chiudi",
    create: "Crea nuova",
    createAccountingRecord: "Nuova registrazione",
    confirmModal1: "Continuando perderai tutte le modifiche fatte fin'ora.",
    confirmModal2: "Sei sicuro di voler continuare?",
    deadline: "Scadenza del ",
    deadlineImport: "Importo totale: ",
    paymentMode: "Modalità di pagamento: ",
    feedbackMessageSuccess: "Registrazione contabile presa in carico.",
    feedbackMessageError: "Spiacente. C'è stato un errore nel salvataggio.",
    message: {
      send: "Invia",
      placeholder: "Lascia un commento",
      error: "Si è verificato un errore",
    },
    label: {
      registrationDate: "Data di registrazione",
      customer: "Cliente",
      supplier: "Fornitore",
      reason: "Causale",
      sectionalActivity: "Sezionale - Attività",
      accountingIdentifier: "Numero documento",
      movimentDate: "Data documento",
      docDescription: "Descrizione documento",
    },
    modalNew: {
      title: "Nuova registrazione",
      description1: "La causale determina i dettagli che dovrai aggiungere.",
      description2: "Scegli con cura!",
      selectReason: "Seleziona causale",
    },
    filters: {
      purchase: "Acquisto",
      sale: "Vendita",
      bank_Transaction: "Movimenti bancari",
      compensation: "Corrispettivi",
      documents: "Documenti",
      toPaid: "Da pagare",
      paid: "Pagate",
      partially_paid: "Parzialmente pagate",
    },
    typeFilters: {
      STATUTORY: "Civilistico",
      TAX: "Fiscale",
      IRAP: "IRAP",
      TAX_RELIEF: "Agevolazioni fiscali",
    },
    header: {
      document: "Documento",
      receipt: "Ricevuto il ",
      vat: "P. IVA ",
      customer: "Cliente ",
      privateSale: "Vendita a privato",
      supplier: "Fornitore ",
      sdiId: "SDI Id",
      reason: "Causale",
      activity: "Attività",
      sectional: "Sezionale",
      vatCompetence: "Competenza IVA",
      vatCollectability: "Esigibilità IVA",
      SPLIT_PAYMENT: "Split payment",
      DEFERRED: "IVA differita",
      IMMEDIATE: "Esigibilità immediata",
      ordinary: "Ordinaria",
      registrationDate: "Data di registrazione",
      docTotal: "Totale documento",
      movementTotal: "Totale movimento",
      documentTotal: "Totale documento",
      taxable: "Imponibile",
      tax: "Imposta",
      vatRegime: "Regime IVA",
    },
    accountingLines: {
      table: {
        accountingAccount: "Conto Contabile",
        previousBalance: "Saldo precedente",
        vat: "IVA",
        regime: "Regime",
        rate: "Aliquota",
        destination: "Destinazione",
        give: "Dare",
        have: "Avere",
        amount: "Importo",
        taxable: "Imponibile",
        tax: "Imposta",
        startEndDate: "Inizio e fine competenza",
      },
    },
    accountingTab: {
      accounting: "Contabilità",
      regime: "Regime",
      rate: "Aliquota",
      destination: "Destinazione",
      receipt: "Ricezione",
      receiptType: "Corrispettivo",
      sdi: "SDI",
      amountDescription: "Importo",
      client: "Cliente",
      supplier: "Fornitore",
      collectability: "Esigibilità IVA",
      reverseCharge: "Reverse Charge",
      sectional: "Sezionale",
      reason: "Causale contabile",
      accountingAccount: "Conto contabile",
      debit: "Dare",
      credit: "Avere",
      fixedAsset: "Cespite",
      deferredInvoice: "Fattura differita",
      additions: "Integrazioni",
      tooltipTitle: "Fattura di {type} con ritenute",
      documents: "Documenti",
      registration: "Registrazione contabile",
      accountingSelected: "Contabilizza selezionati",
      showOtherAccounts: "Vedi altri conti",
      hideAccounts: "Nascondi",
      beneficiary: "Beneficiario",
      orderer: "Ordinante",
      change: "Modifica",
      delete: "Elimina",
      invoicesRef: "Rif. Fatture",
      movementDate: "Data operazione",
      noResults_filtered: "La tua ricerca non ha prodotto nessun risultato",
      noResults_accounted: "Non sono presenti movimenti contabilizzati",
      noResults_tryAgain: "Prova a impostare filtri differenti o ad annullare tutti i filtri",
      noResults_error: "Spiacenti, si è verificato un errore. Prova a ricaricare la pagina",
      noResults_deferrals: "Non sono presenti risconti",
      moveTo: "Sposta in",
      regimeSelect: "Seleziona il regime",
      aliquoteSelect: "Seleziona l'aliquota",
      exemptionNature: "Natura esenzione",
      destinationSelect: "Seleziona la destinazione",
    },
    drawerDetail: {
      ledger: "Partitario",
      articles: "Articoli",
      accountRegistry: "Anagrafica conto",
      contoSelect: "Seleziona conto",
      accountLedger: "Partitario del conto",
      initialBalance: "Saldo iniziale",
      registrationDate: "Data registrazione",
      selectAll: "Seleziona tutti",
      noArticles: "In questo conto contabile non sono presenti articoli.",
      showAll: "Vedi tutto",
      accountDescription: "Descrizione conto",
      noDeductibility: "Indeducibilità",
      irpefOrIres: "IRPEF/IRES",
      fiscalIrap: "IRAP metodo fiscale",
      civilisticIrap: "IRAP: metodo civilistico",
      nonDeductibilityPercentage: "% di indetraibilità",
      vatDestination: "Destinazione IVA",
      accountType: {
        label: "Tipo conto",
        BALANCE_SHEET: "Patrimoniale",
        INCOME_STATEMENT: "Economico",
      },
      subjectToWitholdingTax: "Soggetto a ritenuta d'acconto",
      fixedAssetsAccount: "Conto immobilizzi",
      subjectToSuspension: "Soggetto a sospensione",
    },
    usedGoods: {
      title: "Bene usato",
      sell: "Vendita",
      buy: "Acquisto",
      usedGoodsRegistry: "Anagrafica bene usato",
      accessoryExpense: "Spesa accessoria",
      selectUsedGoods: "Seleziona bene esistente",
      identificationData: "Dati identificativi",
      articles: "Articoli",
      quantity: "Quantità",
      buyDate: "Data di acquisto",
      idCode: "Cod. identificativo",
      description: "Descrizione",
      searchExistingGoods: "Cerca bene esistente",
      supplier: "Fornitore",
      description: "Descrizione",
      buyDate: "Data acquisto",
      total: "Importo",
      fixed: {
        description: "Descrizione",
        selection: "Seleziona",
        idCode: "Cod. identificativo",
        buyDate: "Data acquisto",
        sellDate: "Data vendita",
        search: "Cerca",
        totalPurchase: "Totale acquisto",
        marginAmount: "Margine lordo",
        accessories: "Spese accessorie",
        status: "Stato",
        table: {
          empty: {
            title: "Nessun bene usato",
          },
          NOT_SOLD: "Non venduto",
          SOLD: "Venduto",
        },
      },
    },
    assetsTab: {
      assets: "Cespiti",
      usedGoods: "Beni usati",
      fiscal_payments: "Incassi e pagamenti",
      register: "Registra per",
      assetsTotal: "Tot cespiti",
      assetsData: "Dati cespite",
      confirm: "Conferma",
      newAsset: "Nuovo cespite",
      existingAsset: "Cespite esistente",
      accountingLine: "Conto contabile",
      separatedDeprecation: "Mov.ammortamento indeducibile separato",
      save: "Salva",
      back: "Indietro",
      drawer: {
        disabled: "Per poter operare sui cespiti è necessario selezionare un'attività.",
        accountAssetsDetail: {
          drawerTitle: "Dati cespite",
          names: {
            fundAccount: "Conto fondi",
            depreciationRateAccount: "Conto quote ammortamento",
            capitalLossAccount: "Conto minusvalenze",
            capitalGainAccount: "Conto plusvalenze",
            toBeDividedCapitalGainAccount: "Conto plusvalenze da ripartire",
            revaluationAccount: "Conto rivalutazione",
            anticipatedDepreciationRateAccount: "Conto quote ammortamento anticipate",
            nonDeductibleDepreciationRateAccount: "Conto quote ammortamento indeducibile",
            disposalAccount: "Conto eliminazione processo produttivo",
            anticipatedDepreciationFundAccount: "Conto fondo ammortamento anticipato",
            nonTaxableCapitalGainAccount: "Conto plusvalenza non tassabile",
            nonDeductibleCostsAccount: "Conto costi indeducibili",
            nonDeductibleCostAccount: "Conto costi indeducibili",
            nonDeductibleDisposalAccount: "Conto eliminazione non deducibile",
            goodType: "Tipo bene deduz. extracontabili (Quadro EC Rediti)",
            parametersGoodType: "Tipo bene PARAMETRI",
            professionalCapitalLossAccount: "Conto minusvalenze professionisti",
            professionleCapitalGainAccount: "Conto plusvalenze professionisti",
            otherTaxDebts: "Altri debiti tributari",
          },
          type: {
            PURCHASE: "Acquisto",
            INCREASE: "Incremento",
            SUSPENDED: "Sospensione",
            ACTIVE: "Attivazione",
            DEPRECIATION: "Ammortamento",
            SALE: "Vendita",
            REVALUATE: "Rivalutazione",
            PARTIALLY_SALE: "Vendita Parziale",
            DISMISS: "Dismissione",
            PARTIALLY_DISMISS: "Dismissione Parziale ",
          },
        },
        fixedAsset: "Movimenti cespiti",
        registry: "Anagrafica",
        depreciation: "Ammortamento",
        movementsTitle: "Movimenti",
        existingAssetValue: "Valore cespite esistente",
        residualAt: "Residuo al",
        activationDate2: "Data attivazione",
        identificationData: "Dati identificativi",
        availabilityAndDeducibility: "Disponibilità e deducibilità",
        searchExistingAsset: "Cerca cespite esistente *",
        existingAsset: "Cespite esistente",
        newOperation: "Nuova operazione",
        incrementExistingAsset: "Incremento cespite esistente",
        alias: "Cod. identificativo",
        filterResults: "Filtra i risultati",
        cancelFilters: "Annulla filtri",
        results: "Risultati",
        date: "Data",
        supplier: "Fornitore",
        lookForSupplier: "Cerca Fornitore",
        amount: "Valore",
        group: "Gruppo:",
        kind: "Specie:",
        subKind: "Sottospecie: ",
        materialGood: "Bene materiale",
        isNonMaterialGood: "Bene immateriale",
        new: "Nuovo",
        used: "Usato",
        assetFullDescription: "Descrizione aggiuntiva",
        activationDate: "Attivazione",
        suspensionDate: "Disattivazione",
        availabilityDate: "Disponibilità",
        isReducedDeductibility: "Deducibilità ridotta",
        deductability_50: "Indeducibilità al 50%",
        business_motorvehicles: "Autoveicoli aziendali",
        business_motorcycles: "Motocicli aziendali",
        business_mopeds: "Ciclomotori aziendali",
        representatives_motorvehicles: "Autoveicoli rappresentanti",
        representatives_motorcycles: "Motocicli rappresentanti",
        representatives_mopeds: "Ciclomotori rappresentanti",
        non_deductible_100: "Indeducibilità al 100%",
        building_land: "Fabbricato con terreno",
        fixed_telephony: "Telefonia fissa 80%",
        mobile_telephony: "Telefonia mobile 80%",
        reducedDeductibilityExtraField: "Valore del terreno",
        mixedUseSelect: "Uso promiscuo",
        assignmentDateToEmployee: "Data assegnazione",
        revocationDateToEmployee: "Data revoca",
        depreciationRate: "Percentuale ammortamento",
        taxAmortization: "Ammortamento fiscale",
        statutoryDepreciationType: "Ammortamento civilistico",
        irapAmortization: "Ammortamento IRAP",
        otherDepreciationCriteria: "Altri criteri di ammortamento",
        taxRelief: "Agevolazioni",
        anticipate: "Anticipata {percentage}",
        irapPercent: "% IRAP",
        min: "Minima {percentage}",
        MANUAL: "Manuale {percentage}",
        DYNAMIC: "Dinamica {percentage}",
        ORDINARY: "Di legge {percentage}",
        sellingDepreciation: "Ammortamento in vendita",
        otherFiscalData: "Altri dati fiscali",
        TAX_CRITERIA: "Come da criteri fiscali",
        PERIOD: "Periodo d'utilizzo",
        DATA_END_PERIOD: "Data fine periodo",
        FIXED_PERCENTAGE: "Percentuale fissa",
        DESC_METHOD: "Metodo decrescente / Americano",
        otherFiscalAspects: "Altri aspetti civilistici",
        civilDepreciationValue_period: "Data fine periodo",
        civilDepreciationValue_fixed_percentage: "Percentuale fissa",
        civilDepreciationValue_desc_method: "N° di esercizi in cui ammortizzare il bene",
        fillPercentage: "Indica la percentuale",
        statutoryDepreciationValue_FIXED_PERCENTAGE: "Percentuale ammortamento",
        statutoryDepreciationValue_DESC_METHOD: "Anni ammortamento",
        statutoryDepreciationValue_PERIOD: "Data fine ammortamento",
        halfFirstYear: "50% primo anno",
        reportInDays: "Ragguaglia in giorni",
        distributeCapitalGains: "Da ripartire",
        relief: "Agevolazioni",
        taxRelief: "Agevolazioni fiscali",
        taxReliefType: "Tipo agevolazioni",
        taxReliefDate: "Data agevolazione",
        _2016_BALANCE_LAW: "L. di Bilancio 2016",
        _2017_BALANCE_LAW: "L. di Bilancio 2017",
        _2018_BALANCE_LAW: "L. di Bilancio 2018",
        _2019_BALANCE_LAW: "L. di Bilancio 2019",
        _2019_GROWTH_DECREE: "D. Crescita 2019",
        _2020_BALANCE_LAW: "L. di Bilancio 2020",
        BASE: "Base",
        BASE4: "Base 4.0",
        SW4: "Software 4.0",
        selectedExisting: {
          type: "Tipo",
          operationDate: "Data operazione",
          sellingPercentage: "Percentuale di vendita",
          sellingValue: "Valore di vendita",
          ammortizationDuringYear: "Ammortamento in corso d'anno",
          civilisticCapitalGain: "Plusvalenza civilistica",
          civilisticCapitalLoss: "Minusvalenza civilistica",
          fiscalCapitalGain: "Plusvalenza fiscale",
          fiscalCapitalLoss: "Minusvalenza fiscale",
          description: "Descrizione",
          showMovements: "Guarda tutti i movimenti",
          purchase: "Spesa incrementativa",
          sale: "Vendita",
          SALE: "Venta",
          value: "Valore",
        },
        buttons: {
          delete: "Eliminazione",
          revaluation: "Rivalutazione",
          addMovements: "Aggiungi movimento",
          backButton: "Movimenti cespiti",
        },
        logs: {
          purchaseTitle: "Aquisto iniziale",
          increaseTitle: "Spesa incrementativa",
          purchaseDocInfoTitle: "Dati del documento",
          docOpsInfoTitle: "Dati dell'operazione",
          docDate: "Data documento",
          docNumber: "Numero documento",
          docTaxRegion: "Ragione sociale fornitore",
          purchaseDate: "Data aquisto",
          invoiceAmount: "Valore del cespite",
          nonDeductibleVat: "Iva indetraibile",
          ancillaryCharges: "Oneri accessori",
          totalToBeDepreciated: "Totale da ammortizzare",
          depreciationTitle: "Ammortamento",
          depreciationDate: "Data ammortamento",
          depreciationPercentage: "% ammortamento",
          depreciationQuote: "Quota ammortamento",
          residualDepreciation: "Residuo ammortizzabile",
          accumulatedDepreciation: "Fondo ammortamento",
          suspensionPercentage: "% di sospensione",
          disposalDocInfoTitle: "Dismissione",
          disposalDate: "Data eliminazione",
          disposalPercentage: "% di eliminazione",
          saleDepreciation: "Amortamento in vendita",
          nonDeductibilityPercentage: "Amortamento idenducibile",
          revaluationDocInfoTitle: "Rivalutazione",
          revaluationDate: "Data rivalutazione",
          revaluationType: "Tipo rivalutazione",
          revalutationScope: "Ambito di applicazione",
          currentValue: "Valore corrente del bene",
          revaluationAmount: "Importo della rivalutazione",
          saleTitle: "Vendita",
          saleDate: "Data vendita",
          saleLogAmount: "Prezzo vendita",
          saleRate: "% vendita",
          capitalGainStatutory: "Plusvalenza civilistica",
          capitalLossStatutory: "Minusvalenza civisiltica",
          capitalGainTax: "Plusvalenza fiscale",
          capitalLossTax: "Minusvalenza fiscale",
          saleCarryingValue: "Residuo da ammortizzare",
        },
        movements: {
          loading: "Caricamento dati in corso. Si prega di attendere.",
          amount: "Importo",
          residue: "Residuo",
          confirmRevaluation: "Conferma rivalutazione",
          backToMovements: "Torna a movimenti",
          revaluation: "Rivalutazione",
          currentAssetValue: "Valore corrente del cespite",
          effectiveDate: "Data efficacia rivalutazione ",
          movementType: "Tipo di movimento ",
          applicationType: "Ambito di applicazione ",
          TAX: "Fiscale",
          STATUTORY: "Civilistico",
          STATUTORY_AND_TAX: "Civilistico e fiscale",
          REV_COST: "Rivalutazione del costo storico",
          REV_COST_AND_FUND: "Rivalutazione del costo storico e del fondo",
          DECR_FUND: "Decremento del fondo",
          revaluationSuccess: "Operazione effettuata con successo",
          revaluationError: "Si è verificato un errore! operazione non effettuata con successo",
          simulationRevaluationError: "Si è verificato un errore! Simulazione della rivalutazione fallita: ",
          next: "Avanti",
          removeConfirm: "Conferma eliminazione",
          backToMovements: "Torna a movimenti",
          delete: "Eliminazione",
          eliminationData: "Dati eliminazione",
          revaluationData: "Dati rivalutazione",
          previewAccount: "Anteprima contabile",
          taxLoss: "Minusvalenza fiscale",
          civilLoss: "Minusvalenza civilistica",
          deletePercentage: "Percentuale eliminazione",
          note: "Note",
          placeholderOperationDescription:
            "Inserisci qui eventuali dati aggiuntivi come: motivo dismissione, numero e data del verbale di distruzione o la denuncia di furto, smarrimento, ecc.",
          assetDelete: "Eliminazione cespite",
          accountDescDebit: "Fondo ammortamento attrezzature industriali e commerciali",
          accountDescCredit: "Eliminazione/distruzione cespite (719)",
          sectional: "Sezionale",
          causalAccounting: "Causale contabile",
          accountingAccount: "Conto contabile",
          give: "Dare",
          have: "Avere",
        },
        deductibilityGoods: {
          NONE: "Indeducibilità al 100%",
          HALF: "Indeducibilità al 50%",
          BUSINESS_VEHICLES: "Autoveicoli aziendali",
          BUSINESS_MOTORCYCLES: "Motocicli aziendali",
          BUSINESS_MOPEDS: "Ciclomotori aziendali",
          REPRESENTATIVES_VEHICLES: "Motocicli rappresentanti",
          REPRESENTATIVES_MOTORCYCLES: "Autoveicoli rappresentanti",
          REPRESENTATIVES_MOPEDS: "Ciclomotori rappresentanti",
          BUILDING_AND_LAND: "Fabbricato con terreno",
          FIXED_TELEPHONY: "Telefonia fissa 80%",
          MOBILE_TELEPHONY: "Telefonia mobile 80%",
        },
      },
      tooltips: {
        identificationCode: "Inserisci targa, numero di protocollo, cod inventario o alias.",
        activationDate: "Ragguaglia in giorni solo per il primo o ultimo anno di attività, se la data inizio o chiusura attività è diversa dall’1/1.",
        deactivationDate: "In caso di vendita conteggia solo i giorni effettivi di possesso.",
        sellingDepreciation: "In caso di vendita conteggia solo i giorni effettivi di possesso.",
        reportDays:
          "Riproporziona l'ammortamento in giorni solo per i movimenti che si riferiscono all' esercizio contabile dell'anno di costituzione e di cessazione dell'azienda.",
      },
    },
    intrastatTab: {
      intrastat: "Intrastat",
      addRow: "Aggiungi nomenclatura",
      registrationDate: "Data registrazione intra *",
      reason: "Registra per *",
      total: "Tot da dichiarare",
      difference: "Differenza",
      description: "Descrizione nomenclatura",
      triangulation: "Triangolazione",
      originProvince: "Provincia d'origine",
      originCountry: "Paese d'origine",
      transactionCodeA: "Natura transazione A *",
      transactionCodeB: "Natura transazione B *",
      unitWeight: "Massa netta",
      additionalUnit: "Unità supplementare",
      euroStatisticalAmount: "Valore statico in euro",
      deliveryTerms: "Condizioni di consegna",
      deliveryMode: "Modalità di trasporto",
      destinationCountry: "Paese di destinazione",
      shipmentOriginCountry: "Paese di provenienza",
      provinceDestination: "Provincia di destinazione",
      deliveryMethod: "Modalità di erogazione",
      collectionMode: "Modalità d'incasso",
      paymentCountry: "Paese di pagamento",
      customCode: "Sezione doganale",
      referenceFrequency: "Periodicità del modello da rettificare",
      referencePeriod: "Periodo di riferimento",
      correctionYear: "Anno",
      originalIntrastatRecord: "Protocollo di dichiarazione",
      statementNumber: "Progressivo sezione 3",
      state: "Stato",
      monthly: "Mensile",
      annual: "Annuale",
      tooltips: {
        combinedNomenclature:
          "É possibile compilare gli elenchi riepilogativi senza disaggregazione della Nomenclatura combinata, utilizzando il codice unico 99500000, per le spedizioni di valore inferiore a euro 1.000. Per «spedizione» si intendono tutte le transazioni che durante il mese di riferimento sono oggetto della stessa fattura.",
        amount: "Le imposte sulla produzione e sui consumi pagate o da pagare in Italia non vanno comprese in detto ammontare.",
        unitWeight:
          "Indicare la massa netta, espressa in chilogrammi, delle merci prive di tutti i loro imballaggi. Per le sottovoci della nomenclatura combinata che prevedono anche l’unità supplementare, la colonna deve essere compilata esclusivamente dai soggetti che hanno realizzato nell'anno precedente o, in caso d'inizio dell'attivita' di scambi intracomunitari, presumono di realizzare nell'anno in corso, un valore delle spedizioni o degli arrivi superiore ad euro 20.000.000",
        euroStatisticalAmount:
          "La colonna deve essere compilata: a) dai soggetti che hanno realizzato nell'anno precedente o, in caso d'inizio dell'attivita' di scambi intracomunitari, presumono di realizzare nell'anno in corso, un valore delle spedizioni o degli arrivi superiore ad euro 20.000.000 indicano i dati relativi al valore statistico, alle condizioni di consegna ed al modo di trasporto nella parte statistica degli elenchi relativi alle cessioni intracomunitarie e, rispettivamente, agli acquisti intracomunitari di cui all'art. 1, comma 1, lettera a), n. 1) e di cui all'art. 1, comma 1, lettera b), n. 1). b) dagli altri soggetti, soltanto nel caso in cui, conformemente alle disposizioni in materia di imposta sul valore aggiunto, non è stata compilata la colonna 4.",
        deliveryTerms:
          "* I soggetti che hanno realizzato nell'anno precedente o, in caso d'inizio dell'attivita' di scambi intracomunitari, presumono di realizzare nell'anno in corso, un valore delle spedizioni o degli arrivi superiore ad euro 20.000.000 indicano i dati relativi al valore statistico, alle condizioni di consegna ed al modo di trasporto nella parte statistica degli elenchi relativi alle cessioni intracomunitarie e, rispettivamente, agli acquisti intracomunitari di cui all'art. 1, comma 1, lettera a), n. 1) e di cui all'art. 1, comma 1, lettera b), n. 1).",
        deliveryMode:
          "* I soggetti che hanno realizzato nell'anno precedente o, in caso d'inizio dell'attivita' di scambi intracomunitari, presumono di realizzare nell'anno in corso, un valore delle spedizioni o degli arrivi superiore ad euro 20.000.000 indicano i dati relativi al valore statistico, alle condizioni di consegna ed al modo di trasporto nella parte statistica degli elenchi relativi alle cessioni intracomunitarie e, rispettivamente, agli acquisti intracomunitari di cui all'art. 1, comma 1, lettera a), n. 1) e di cui all'art. 1, comma 1, lettera b), n. 1).",
        shipmentOriginCountry:
          "*Qualora le merci, prima di entrare in Italia, abbiano fatto sosta in uno o più Stati membri per operazioni non inerenti al trasporto, indicare il codice dello Stato membro in cui si è verificata l’ultima sosta.",
        destinationCountry: "Indicare il codice ISO del Paese membro di destinazione delle merci",
        originCountry:
          "Le merci interamente ottenute o prodotte in un unico Stato membro o paese o territorio sono originarie di tale Stato membro o paese o territorio. Le merci la cui produzione riguarda più di uno Stato membro o paese o territorio sono considerate originarie dello Stato membro o paese o territorio in cui sono state sottoposte all’ultima trasformazione o lavorazione sostanziale, economicamente giustificata, effettuata in un’impresa attrezzata a tale scopo, che abbia determinato la fabbricazione di un prodotto nuovo o che rappresenta uno stadio importante del processo di fabbricazione. L’origine delle merci non unionali è determinata conformemente alle disposizioni del codice doganale dell’Unione che stabilisce le norme in materia di origine.",
        originProvince:
          "Se la provincia di origine/produzione non è nota oppure non è italiana, indicare la sigla automobilistica della provincia di spedizione delle merci",
        destinationProvince:
          "Indicare la sigla automobilistica della provincia in cui le merci sono destinate al consumo o alla commercializzazione ovvero assoggettate ad operazioni di perfezionamento.",
        deliveryMethod: "Indicazione facoltativa per elenchi riepilogativi con periodo di riferimento decorrenti dall’anno 2015",
        collectionMode: "Indicazione facoltativa per rettifiche ad elenchi riepilogativi con periodo di riferimento decorrenti dall’anno 2015",
        paymentCountry: "Indicare il Codice ISO del Paese in cui viene effettuato il pagamento del servizio reso.",
        customCode: "Indicare il codice dell’ufficio doganale al quale è stato presentato l’elenco da rettificare.",
      },
    },
    fiscalPayments: {
      titleRegister: "Registra pagamento contestuale",
      titleInvoice1: "Fatture di vendita ",
      titleInvoice2: " da incassare",
      titleAssociate: "Associa pagamenti in acconto per TeamSystem",
      subtitleTableAdvances: "Seleziona uno o più pagamenti già registrati, da associare a questo documento",
      subtitleTableInvoices: "Seleziona una o più fatture da associare al movimento di cassa appena registrato",
      searchLedgerAccount: "Cerca conto contabile",
    },
    deadlinesTab: {
      deadlines: "Scadenze",
    },
    withholdingsTab: {
      drawer: {
        masterTitle: "Ritenuta d'acconto",
        title: "Sezione ritenute d'acconto",
        titleInps: "Sezione inps",
        fields: {
          amount: "Base imponibile ritenuta",
          taxableAmount: "Base imponibile ritenuta",
          totalNetAmount: "Totale fattura netto IVA",
          withholdingRate: "Aliquota % ritenuta",
          reason: "Causale prestazione",
          cuReason: "Causale per modello CU",
          cashContribution: "Contributo integrativo",
          notIncomeAmount: "Somme non costituenti reddito",
          exemptIncome: "Reddito esente",
          notWithholdingIncome: "Reddito non soggetto a ritenuta",
          // taxableAmount: "Imponibile ritenuta d'acconto",
          withHoldingDepositAmount: "Importo ritenuta a titolo di acconto ",
          withHoldingTaxAmount: "Importo ritenuta a titolo d’imposta",
          taxableContribution: "Imponibile ritenuta",
          tributeCode: "Codice tributo",
          socialInstituteTaxableAmount: "Imponibile INPS",
          socialInstituteContributionRate: "Percentuale contributo INPS",
          alreadySubjectedAmount: "Importo già assoggettato",
          recipientContribution: "Contributo a carico percipiente",
          companyContribution: "Contributo a carico ditta",
          activityStartDate: "Periodo attività dal",
          activityEndDate: "Periodo attività al",
          emensReportType: "EMENS - Tipo rapporto",
          emensActivityCode: "EMENS - Codice attività",
          emensOtherInsurance: "EMENS - Altra assicurazione",
          ensarcoContribution: "Contributo ENSARCO",
          enpamContribution: "Contributo ENPAM",
          othersContribution: "Altri contributi previdenziali",
        },
      },
    },
    vatTab: {
      vat: "Riepilogo IVA",
    },
    bottomBar: {
      error1: "L'importo del documento non può essere pari a 0",
      error2: "Controllare i conti contabili",
      error3: "Controllare i conti IVA",
      error4: "Controllare i dettagli documento",
      saveTime: "meno di un minuto fa",
      goBack: "Indietro",
      confirm: "Contabilizza",
    },
    widget: {
      evidence: {
        title: "In evidenza",
        registrationDate: "Data ultima registrazione contabile",
        documentsContains: "Documenti contenenti:",
        withHoldings: "Ritenute",
        intrastat: "Intrastat",
        assets: "Cespiti",
        nonRegisteredMessage: "Tutti i tuoi documenti sono stati registrati",
      },
      accountedFor: "Da contabilizzare",
      accountedForSubtitle: "Contabilizzati da inizio anno ",
      counterDetail: {
        activeInvoice: "Fatture di vendita",
        passiveInvoice: "Fatture d'acquisto",
        compensation: "Corrispettivi",
        bankMovements: "Movimenti bancari",
        others: "Altri",
      },
      vatSummary: {
        title: "Riepilogo IVA ",
        monthly: "mensile",
        quarterly: "trimestrale",
        MONTHLY: "mensile",
        QUARTERLY: "trimestrale",
        MIXED: "misto",
        mixed: "misto",
        quater: "trimestre",
        tooltip: {
          vatSummary: "Data ultima registrazione",
        },
        vat: "IVA",
      },
      documents: "Documenti",
      btnNew: "Aggiungi doc o xml",
    },
  },
  addressBook: {
    title: "Rubrica",
    empty: "Non ci sono ancora contatti",
    addFirst: "Aggiungi il tuo primo contatto",
    customers: "Clienti",
    suppliers: "Fornitori",
    customer: "Cliente",
    supplier: "Fornitore",
    payments: "Pagamenti",
    create: {
      title: "Nuovo contatto",
      installment: "Rata",
      giorni: "giorni",
      mesi: "mesi",
      installmentAmount: "Ammontare Rata",
      firstChoice: "Data fattura",
      secondChoice: "Data fattura fine mese",
      addInstallment: "Aggiungi rata",
      removeInstallment: "Rimuovi rata",
      paymentMode: { label: "Modalità di pagamento", placeholder: "Seleziona metodo di pagamento" },
      paymentTerms: { label: "Termini di pagamento" },
      businessName: { label: "Ragione sociale", placeholder: "Inserisci la ragione sociale" },
      country: { label: "Nazione di riferimento", placeholder: "Nazione di riferimento" },
      vat: { label: "P.IVA" },
      tax: { label: "Codice Fiscale", placeholder: "Inserisci il codice fiscale" },
      eori: { label: "Codice EORI", placeholder: "Inserisci il codice EORI" },
      name: { label: "Nome", placeholder: "Inserisci il nome" },
      surname: { label: "Cognome", placeholder: "Inserisci il cognome" },
      sdi: { label: "Identificativo SDI/ Codice IPA", placeholder: "Inserisci SDI" },
      addressCountry: { label: "Nazione", placeholder: "Nazione" },
      addressCity: { label: "Comune", placeholder: "Inserisci il comune" },
      addressZip: { label: "Cap" },
      addressProvince: { label: "Provincia", placeholder: "Provincia" },
      addressSpaceType: { label: "Via/Piazza", placeholder: "Inserisci l'indirizzo" },
      addressPec: { label: "PEC", placeholder: "Inserisci PEC" },
    },
  },
  main: {
    studioSelector: {
      title: "Scegli lo studio professionale",
      title2: "con il quale vuoi operare",
    },
    sidebar: {
      home: "Home",
      documents: "Documenti",
      deadlines: "Scadenze",
      customerPage: "Scheda cliente",
      folders: "Fascicoli",
      ask: "Richieste",
      toSign: "Da firmare",
      digitalSignature: "Digital Signature",
      fulfilments: "Adempimenti",
      precog: "Prima Nota",
      accountingYears: "Esercizi contabili",
      accountingPlan: "Piano dei conti",
      reports: "Report",
      reportsOnefront: "Report (OneFront)",
      taxCredit: "Crediti fiscali",
      accounting: "Contabilità e fisco",
      collaboration: "Collaboration",
      customers: "Clienti",
      chartAccounts: "Prima Nota",
      documental: "Documentale",
    },
    userBadge: {
      information: "Informazioni",
      user: "Utente",
      studio: "Studio",
      company: "Azienda",
      fiscalCode: "CF",
      vatNumber: "P.IVA",
      logout: "Esci",
      downloadApp: "Scarica l'App",
      goProfile: "Il mio profilo",
      goAccounts: "I miei studi",
    },
  },
  customers: {
    title: "I MIEI CLIENTI",
    feedback: {
      ok: "Fatto. La richiesta è stata presa in carico. Se il cliente risulta ancora inattivo, controlla che abbia accettato la connessione.",
    },
  },
  validation: {
    status: {
      VALIDATED: "VALIDATA",
      CERTIFIED: "CERTIFICATA",
      UNVERIFIABLE: "NON VALIDATA",
      UNVERIFIABLE_PENDING_VALIDATE: "IN ATTESA DI VALIDAZIONE",
    },
    confirm: "Confermi l'inserimento dei dati?",
    error: {
      title: "Si è verificato un errore",
      message: "Generazione modulo di sottoscrizione",
    },
    feedback: {
      title: "Richiesta inoltrata con successo!",
      message: "La tua richiesta di validazione è stata inoltrata",
      btn: "Torna alla homepage",
    },
    actions: {
      select: "Seleziona",
      cancel: "Annulla",
      edit: "Modifica",
      submit: "Invia richiesta di validazione",
    },
    offices: {
      1: "Titolare",
      2: "Legale rappresentante",
      3: "Procuratore",
    },
    officesDoc: {
      1: "Titolare",
      2: "Legale rappresentante",
      3: "Procuratore",
    },
    data: {
      status: "Stato azienda",
      type: "Tipologia",
      taxId: "Codice fiscale",
      vatNumber: "Partita iva",
      name: "Nome",
      surname: "Cognome",
      office: "Carica",
      city: "Luogo",
      date: "Data",
    },
    form: {
      1: {
        title: "1. Inserisci i tuoi dati e gestisci le tue opzioni di trattamento dei dati",
        subtitle: "Compila i dati richiesti per poter generare il Modulo di sottoscrizione TS Digital precompilato",
        formTitle:
          "Scegli i consensi che desideri rilasciare a TeamSystem Service: un consenso positivo ti permetterà di rimanere aggiornato sulle nostre promozioni. Ricordati che potrai cambiare in qualunque momento la tua scelta.",
        consentLink: "Clicca qui",
        consentTitle: "per prendere visione dell'informativa sul trattamento dei tuoi dati personali.",
        consent1:
          "Autorizzo il trattamento dei miei dati personali, inclusi quelli relativi all'utilizzo del sito e dei prodotti e servizi TeamSystem, per ricevere via email, posta, messaggi istantanei, chat o al telefono aggiornamenti su novità e offerte commerciali di prodotti e servizi TeamSystem, ovvero per le altre iniziative di marketing indicate nell'informativa.",
        consent2:
          "Autorizzo la comunicazione dei miei dati personali alle altre società del gruppo TeamSystem e ai suoi partner per fini commerciali e di marketing.",
        btn: "Prosegui",
      },
      2: {
        title: "2. Genera il Modulo di sottoscrizione per TS Digital",
        subtitle: "Genera il Modulo di sottoscrizione per TS Digital con i dati inseriti precedentemente.",
        btn: "Genera il modulo di sottoscrizione",
      },
      3: {
        title: "3. Carica il Modulo di sottoscrizione per TS Digital",
        subtitle: "Carica il file firmato per proseguire nella validazione.",
        btn: "Carica il modulo di sottoscrizione",
      },
    },
  },
};
